var map = {
	"./2025/1000Icon.png": 218,
	"./2025/1400Icon.png": 219,
	"./2025/1600Icon.png": 220,
	"./2025/900Icon.png": 221,
	"./2025/arrow.gif": 12,
	"./2025/arrow_next.png": 468,
	"./2025/arrow_next2.png": 80,
	"./2025/black-arrow-gif.gif": 1468,
	"./2025/black-arrow.png": 1469,
	"./2025/blue-arrow.gif": 1470,
	"./2025/multiplayerIcon.png": 222,
	"./2025/nextTopic_bg.png": 1471,
	"./2025/topic1000/a_video.png": 1472,
	"./2025/topic1000/a_video_mobile.png": 1473,
	"./2025/topic1000/background-1.png": 1474,
	"./2025/topic1000/background-2.png": 1475,
	"./2025/topic1000/background-3.png": 1476,
	"./2025/topic1000/background-4-mobile.png": 1477,
	"./2025/topic1000/background-4.png": 1478,
	"./2025/topic1000/background-5-1.png": 1479,
	"./2025/topic1000/background-6.png": 223,
	"./2025/topic1000/computer-mobile.png": 224,
	"./2025/topic1000/computer.png": 225,
	"./2025/topic1000/ele_example_1_1.png": 226,
	"./2025/topic1000/ele_example_2_1.png": 227,
	"./2025/topic1000/ele_example_2_2.png": 228,
	"./2025/topic1000/ele_example_3_1.png": 229,
	"./2025/topic1000/ele_example_3_2.png": 230,
	"./2025/topic1000/ele_example_4_1.png": 231,
	"./2025/topic1000/ele_example_4_2.png": 232,
	"./2025/topic1000/ele_example_4_3.png": 233,
	"./2025/topic1000/example_img_1_1.png": 234,
	"./2025/topic1000/example_img_1_2.png": 235,
	"./2025/topic1000/example_img_1_3.png": 236,
	"./2025/topic1000/example_img_1_4.png": 237,
	"./2025/topic1000/example_img_1_5.png": 238,
	"./2025/topic1000/example_img_1_6.png": 239,
	"./2025/topic1000/example_img_1_6_1.png": 240,
	"./2025/topic1000/example_img_1_7.png": 1480,
	"./2025/topic1000/example_img_1_7_1.png": 241,
	"./2025/topic1000/person-back.png": 1481,
	"./2025/topic1000/person-cover.png": 1482,
	"./2025/topic1000/person.png": 1483,
	"./2025/topic1000/quiz_bg.png": 1484,
	"./2025/topic1000/quiz_bg_mobile.png": 1485,
	"./2025/topic1000/section2_4_1.png": 1486,
	"./2025/topic1000/section2_4_3.png": 1487,
	"./2025/topic1000/section2_4_3_m.png": 1488,
	"./2025/topic1000/section2_back.png": 1489,
	"./2025/topic1000/section3_1_0.png": 242,
	"./2025/topic1000/section3_1_1.png": 1490,
	"./2025/topic1000/section3_1_2.png": 243,
	"./2025/topic1000/section3_2_1.png": 244,
	"./2025/topic1000/section3_2_1_cn.png": 245,
	"./2025/topic1000/section3_2_1_sc.png": 246,
	"./2025/topic1000/section3_3_1.png": 247,
	"./2025/topic1000/section3_3_2.png": 248,
	"./2025/topic1000/section3_3_2_m.png": 249,
	"./2025/topic1000/section3_4_1.png": 1491,
	"./2025/topic1000/section3_back.png": 1492,
	"./2025/topic1000/section4/arrow-circle.png": 1493,
	"./2025/topic1000/section4/arrow.png": 1494,
	"./2025/topic1000/section4/background-1.png": 1495,
	"./2025/topic1000/section4/background-2.png": 1496,
	"./2025/topic1000/section4/background-3-mobile.png": 1497,
	"./2025/topic1000/section4/background-3.png": 1498,
	"./2025/topic1000/section4/background-4.png": 1499,
	"./2025/topic1000/section4/background-5.png": 1500,
	"./2025/topic1000/section4/background-6.png": 1501,
	"./2025/topic1000/section4/black-arrow.png": 1502,
	"./2025/topic1000/section4/computer-icon.png": 1503,
	"./2025/topic1000/section4/dialog-box-1-en.png": 1504,
	"./2025/topic1000/section4/dialog-box-1-mobile.png": 1505,
	"./2025/topic1000/section4/dialog-box-1.png": 1506,
	"./2025/topic1000/section4/dialog-box-2-en.png": 1507,
	"./2025/topic1000/section4/dialog-box-2-mobile.png": 1508,
	"./2025/topic1000/section4/dialog-box-2.png": 1509,
	"./2025/topic1000/section4/dialog-box-3-mobile.png": 1510,
	"./2025/topic1000/section4/dialog-box-3.png": 1511,
	"./2025/topic1000/section4/dialog-box-4-mobile.png": 1512,
	"./2025/topic1000/section4/dialog-box-4.png": 1513,
	"./2025/topic1000/section5/background-1.png": 1514,
	"./2025/topic1000/section5/background-2.png": 1515,
	"./2025/topic1000/section5/background-3.png": 1516,
	"./2025/topic1000/section5/blue-box.png": 1517,
	"./2025/topic1000/section5/bottom-decoration.png": 1518,
	"./2025/topic1000/section5/flower-computer.png": 1519,
	"./2025/topic1000/section5/orange-box.png": 1520,
	"./2025/topic1000/section5/persons.png": 1521,
	"./2025/topic1000/spot1.png": 1522,
	"./2025/topic1000/spot2.png": 1523,
	"./2025/topic1000/spot3.png": 1524,
	"./2025/topic1000/warning.png": 1525,
	"./2025/topic1400/elePerson_2_1.png": 250,
	"./2025/topic1400/elePerson_2_2.png": 251,
	"./2025/topic1400/file_bg.png": 1526,
	"./2025/topic1400/file_bg_m.png": 1527,
	"./2025/topic1400/file_bg_m2.png": 1528,
	"./2025/topic1400/file_left_person.png": 252,
	"./2025/topic1400/file_right_img.png": 253,
	"./2025/topic1400/left_icon.svg": 1529,
	"./2025/topic1400/line_left_bg.png": 1530,
	"./2025/topic1400/line_right_bg.png": 1531,
	"./2025/topic1400/news_bg.png": 1532,
	"./2025/topic1400/practice_img.png": 254,
	"./2025/topic1400/practice_left_bg.png": 255,
	"./2025/topic1400/quiz_bg.png": 1533,
	"./2025/topic1400/quiz_bg_mobile.png": 1534,
	"./2025/topic1400/right_icon.png": 256,
	"./2025/topic1400/risk_person.png": 257,
	"./2025/topic1400/section3_3_1.png": 258,
	"./2025/topic1400/section3_3_2.png": 259,
	"./2025/topic1400/section3_3_2_m.png": 260,
	"./2025/topic1400/shared_file_bg.png": 1535,
	"./2025/topic1400/shared_file_bg1.png": 1536,
	"./2025/topic1400/shared_file_bg2.png": 1537,
	"./2025/topic1400/shared_left_bottom.png": 121,
	"./2025/topic1400/top_bg.png": 1538,
	"./2025/topic1400/top_ele1.png": 1539,
	"./2025/topic1400/top_flowers.png": 261,
	"./2025/topic1400/top_icon.png": 1540,
	"./2025/topic1400/top_person.png": 262,
	"./2025/topic1400/top_tips.png": 1541,
	"./2025/topic1400/wrong_icon.png": 263,
	"./2025/topic1600/background-1.png": 1542,
	"./2025/topic1600/background-2.png": 1543,
	"./2025/topic1600/background-3.png": 1544,
	"./2025/topic1600/background-4.png": 1545,
	"./2025/topic1600/background-5-1.png": 1546,
	"./2025/topic1600/background-5.png": 1547,
	"./2025/topic1600/background-6-mobile.png": 1548,
	"./2025/topic1600/background-6.png": 1549,
	"./2025/topic1600/computer.png": 1550,
	"./2025/topic1600/connect-vpn-1.png": 1551,
	"./2025/topic1600/connect-vpn-2.png": 1552,
	"./2025/topic1600/example-1.png": 264,
	"./2025/topic1600/flower-1.png": 1553,
	"./2025/topic1600/flower.png": 1554,
	"./2025/topic1600/header-icon.png": 1555,
	"./2025/topic1600/info-lock.png": 1556,
	"./2025/topic1600/person-1.png": 1557,
	"./2025/topic1600/person-2.png": 1558,
	"./2025/topic1600/person.png": 1559,
	"./2025/topic1600/quiz_bg.png": 1560,
	"./2025/topic1600/quiz_bg_mobile.png": 1561,
	"./2025/topic1600/right-icon.png": 1562,
	"./2025/topic1600/section2_7.png": 265,
	"./2025/topic1600/section2_7_1.png": 266,
	"./2025/topic1600/section2_7_mobile.png": 267,
	"./2025/topic1600/section2_8.png": 268,
	"./2025/topic1600/section2_81.png": 269,
	"./2025/topic1600/section2_9.png": 270,
	"./2025/topic1600/silkRibbon-1.png": 1563,
	"./2025/topic1600/silkRibbon-2.png": 1564,
	"./2025/topic1600/transfer-arrow.png": 1565,
	"./2025/topic1600/vpn-background-1-mobile.png": 1566,
	"./2025/topic1600/vpn-background-1.png": 1567,
	"./2025/topic1600/vpn-background-2-mobile.png": 1568,
	"./2025/topic1600/vpn-background-2.png": 1569,
	"./2025/topic1600/wave.png": 1570,
	"./2025/topic1600/wrong-icon.png": 1571,
	"./2025/topic900/CenterCircle.png": 271,
	"./2025/topic900/arrow_orange_left.png": 1572,
	"./2025/topic900/arrow_r.png": 1573,
	"./2025/topic900/back_1_3.png": 1574,
	"./2025/topic900/back_1_3_m.png": 272,
	"./2025/topic900/back_lines1.png": 1575,
	"./2025/topic900/back_pad1.png": 1576,
	"./2025/topic900/back_piece1.5.png": 1577,
	"./2025/topic900/bottom_left.png": 1578,
	"./2025/topic900/code_icon1.png": 273,
	"./2025/topic900/code_icon2.png": 274,
	"./2025/topic900/code_icon3.png": 275,
	"./2025/topic900/code_icon4.png": 276,
	"./2025/topic900/code_icon5.png": 277,
	"./2025/topic900/code_icon6.png": 278,
	"./2025/topic900/correct_icon.png": 122,
	"./2025/topic900/eleImg_pwd_2_1.png": 1579,
	"./2025/topic900/eleImg_pwd_2_2.png": 1580,
	"./2025/topic900/eleImg_pwd_2_3.png": 1581,
	"./2025/topic900/eleImg_pwd_2_4.png": 1582,
	"./2025/topic900/elePerson1-1.png": 279,
	"./2025/topic900/elePerson_2_1.png": 123,
	"./2025/topic900/elePerson_2_2.png": 124,
	"./2025/topic900/elePerson_2_3.png": 280,
	"./2025/topic900/elePerson_2_4.png": 281,
	"./2025/topic900/ele_Preson_3_2.png": 1583,
	"./2025/topic900/ele_Preson_3_2_m.png": 1584,
	"./2025/topic900/ele_icon_lock.png": 1585,
	"./2025/topic900/en_img.png": 282,
	"./2025/topic900/error_icon.png": 125,
	"./2025/topic900/flower.png": 1586,
	"./2025/topic900/icon1-1.png": 1587,
	"./2025/topic900/icon_clock1.png": 1588,
	"./2025/topic900/icon_correct.png": 1589,
	"./2025/topic900/icon_error.png": 1590,
	"./2025/topic900/icon_flower1.png": 1591,
	"./2025/topic900/icon_text1.png": 1592,
	"./2025/topic900/icon_text2.png": 1593,
	"./2025/topic900/line_bg_2.png": 1594,
	"./2025/topic900/pwd_type1.png": 109,
	"./2025/topic900/pwd_type2.png": 110,
	"./2025/topic900/pwd_type_3_1.png": 173,
	"./2025/topic900/pwd_type_3_3.png": 174,
	"./2025/topic900/pwd_type_3_4.png": 134,
	"./2025/topic900/pwd_type_3_4_1.png": 283,
	"./2025/topic900/quiz_bg.png": 1595,
	"./2025/topic900/quiz_bg_mobile.png": 1596,
	"./2025/topic900/step/step1.png": 869,
	"./2025/topic900/step/step2.png": 870,
	"./2025/topic900/step/step3.png": 871,
	"./2025/topic900/step/step4.png": 872,
	"./2025/topic900/tab/item_bg1.png": 1597,
	"./2025/topic900/tab/item_bg2.png": 1598,
	"./2025/topic900/tab/item_bg3.png": 1599,
	"./2025/topic900/tab/person_tab.png": 284,
	"./2025/topic900/tab/tab1_1.png": 873,
	"./2025/topic900/tab/tab1_2.png": 874,
	"./2025/topic900/tab/tab2_1.png": 875,
	"./2025/topic900/tab/tab2_2.png": 876,
	"./2025/topic900/tab/tab2_3.png": 877,
	"./2025/topic900/tab/tab3_1.png": 878,
	"./2025/topic900/tab/tab3_2.png": 879,
	"./2025/topic900/verify/verify_bg1.png": 880,
	"./2025/topic900/verify/verify_bg2.png": 881,
	"./2025/topic900/verify/verify_bg3.png": 882,
	"./2025/topic900/verify/verify_bg4.png": 883,
	"./2025/topic900/verify/verify_icon1.png": 884,
	"./2025/topic900/verify/verify_icon2.png": 885,
	"./2025/topic900/verify/verify_icon3.png": 886,
	"./2025/topic900/verify/verify_icon4.png": 887,
	"./2025/topic900/video_3people.png": 1600,
	"./2025/topic900/video_3people_m.png": 1601,
	"./2025/topicAI/bg-risk.png": 469,
	"./2025/topicAI/bg1.png": 1602,
	"./2025/topicAI/bg2.png": 1603,
	"./2025/topicAI/h5-bg1.png": 1604,
	"./2025/topicAI/icon1.png": 470,
	"./2025/topicAI/icon2.png": 366,
	"./2025/topicAI/icon3.png": 367,
	"./2025/topicAI/img-splice-1.png": 471,
	"./2025/topicAI/img-splice-2.png": 472,
	"./2025/topicAI/img-splice-3.png": 473,
	"./2025/topicAI/section1-bg1.png": 474,
	"./2025/topicAI/section2-icon1.png": 475,
	"./2025/topicAI/section2-icon2.png": 476,
	"./2025/topicAI/section2-img1.png": 477,
	"./2025/topicAI/section2-img3.png": 1605,
	"./2025/topicAI/￼section2-img2-h5.png": 478,
	"./2025/topicAI/￼section2-img2.png": 479,
	"./2025/topicQuiz/answer_left.png": 285,
	"./2025/topicQuiz/firework.png": 1606,
	"./2025/topicQuiz/left_test.png": 286,
	"./2025/topicQuiz/not_pass.png": 287,
	"./2025/topicQuiz/pass.png": 288,
	"./2025/topicQuiz/quiz_bg.png": 1607,
	"./2025/topicQuiz/quiz_bg_1.png": 1608,
	"./2025/wPeople1.png": 1609,
	"./2025/wPeople2.png": 1610,
	"./2025/welcomeBg.png": 1611,
	"./2025/welcomeBg_m.png": 1612,
	"./2025/welcomeInfo.png": 1613,
	"./2025/welcomeStarrt.png": 1614,
	"./2025/welcome_bg_left.png": 1615,
	"./3d-speech-bubble.png": 1616,
	"./817w2.png": 480,
	"./817w3.png": 481,
	"./9881.png": 1617,
	"./9882.png": 1618,
	"./Artboard 20 1.svg": 1619,
	"./Artboard 20 2.svg": 1620,
	"./Boss-right.png": 1621,
	"./CSRealCase1-en-moblie.jpg": 888,
	"./CSRealCase1-en.jpg": 889,
	"./CSRealCase1-moblie.jpg": 890,
	"./CSRealCase1.jpg": 891,
	"./CSRealCase1.png": 1622,
	"./CSRealCase2-en-moblie.jpg": 892,
	"./CSRealCase2-en.jpg": 893,
	"./CSRealCase2-moblie.jpg": 894,
	"./CSRealCase2.jpg": 895,
	"./CSRealCase3-en-moblie.jpg": 896,
	"./CSRealCase3-en.jpg": 897,
	"./CSRealCase3-moblie.jpg": 898,
	"./CSRealCase3.jpg": 899,
	"./CommonInternetWhalingAttacks1.jpg": 900,
	"./CommonInternetWhalingAttacks1.png": 1623,
	"./CommonInternetWhalingAttacks2.jpg": 901,
	"./CommonInternetWhalingAttacks2.png": 1624,
	"./CommonInternetWhalingAttacks3.jpg": 902,
	"./CommonInternetWhalingAttacks3.png": 1625,
	"./CommonInternetWhalingAttacks4.jpg": 903,
	"./CommonInternetWhalingAttacks4.png": 1626,
	"./CustomerRealCase1-en-moblie.jpg": 904,
	"./CustomerRealCase1-en.jpg": 905,
	"./CustomerRealCase1-moblie.jpg": 906,
	"./CustomerRealCase1.jpg": 907,
	"./E-commerce-gif1.gif": 1627,
	"./E-commerce-gif2.gif": 1628,
	"./E-commerce-gif3.gif": 1629,
	"./E-commerce-gif4.gif": 1630,
	"./E-commerceRealCase1-en.jpg": 908,
	"./E-commerceRealCase1-moblie-en.jpg": 909,
	"./E-commerceRealCase1-moblie.jpg": 910,
	"./E-commerceRealCase1.jpg": 911,
	"./E-commerceRealCase2-en.jpg": 912,
	"./E-commerceRealCase2-mobile.jpg": 913,
	"./E-commerceRealCase2-moblie-en.jpg": 914,
	"./E-commerceRealCase2-moblie.jpg": 915,
	"./E-commerceRealCase2.jpg": 916,
	"./Finance.png": 482,
	"./FinanceRealCase-en.jpg": 917,
	"./FinanceRealCase-mobile-en.jpg": 918,
	"./FinanceRealCase-mobile-sc.jpg": 919,
	"./FinanceRealCase-mobile.jpg": 920,
	"./FinanceRealCase-sc.jpg": 921,
	"./FinanceRealCase.jpg": 922,
	"./FinanceRealCase.png": 1631,
	"./FinanceRealCase2-en.jpg": 923,
	"./FinanceRealCase2-mobile-en.jpg": 924,
	"./FinanceRealCase2-mobile-sc.jpg": 925,
	"./FinanceRealCase2-mobile.jpg": 926,
	"./FinanceRealCase2-sc.jpg": 927,
	"./FinanceRealCase2.jpg": 928,
	"./G5584.png": 1632,
	"./Group5600.png": 1633,
	"./HRRealCase-en.jpg": 929,
	"./HRRealCase-mobile-en.jpg": 930,
	"./HRRealCase-mobile.jpg": 931,
	"./HRRealCase.jpg": 932,
	"./IT.png": 483,
	"./ITRealCase.svg": 1634,
	"./ITRealCase1-en.jpg": 933,
	"./ITRealCase1-moblie-en.jpg": 934,
	"./ITRealCase1-moblie.jpg": 935,
	"./ITRealCase1.jpg": 936,
	"./ITRealCase2-en.jpg": 937,
	"./ITRealCase2-moblie-en.jpg": 938,
	"./ITRealCase2-moblie.jpg": 939,
	"./ITRealCase2.jpg": 940,
	"./ITRealCase3-en.jpg": 941,
	"./ITRealCase3-moblie-en.jpg": 942,
	"./ITRealCase3-moblie.jpg": 943,
	"./ITRealCase3.jpg": 944,
	"./IndexPrompt.jpg": 945,
	"./IndexPrompt.png": 1635,
	"./Introduction.png": 1636,
	"./Lady.svg": 1637,
	"./Link.png": 152,
	"./Ma009-1.svg": 1638,
	"./Ma009-2.svg": 1639,
	"./Ma009-3.svg": 1640,
	"./Ma009-4.svg": 1641,
	"./Ma009-5.svg": 1642,
	"./Ma009-6.svg": 1643,
	"./Manufacturing.png": 1644,
	"./MarketRealCase.jpg": 946,
	"./MarketRealCase1-en-moblie.jpg": 947,
	"./MarketRealCase1-en.jpg": 948,
	"./MarketRealCase1-moblie.jpg": 949,
	"./MarketRealCase1.jpg": 950,
	"./MarketRealCase1.png": 1645,
	"./MarketRealCase1.svg": 1646,
	"./MarketRealCase2-en-moblie.jpg": 951,
	"./MarketRealCase2-en.jpg": 952,
	"./MarketRealCase2-moblie.jpg": 953,
	"./MarketRealCase2.jpg": 954,
	"./MarketRealCase3-en.jpg": 955,
	"./Mc001-Picture1.png": 1647,
	"./Mc001-Picture2.png": 1648,
	"./Mc001-Picture3.png": 1649,
	"./NGORealCase1-en.jpg": 956,
	"./NGORealCase1-moblie-en.jpg": 957,
	"./NGORealCase1-moblie.jpg": 958,
	"./NGORealCase1.jpg": 959,
	"./NGORealCase2-en.jpg": 960,
	"./NGORealCase2-moblie-en.jpg": 961,
	"./NGORealCase2-moblie.jpg": 962,
	"./NGORealCase2.jpg": 963,
	"./PPII.png": 1650,
	"./Pictureds1.png": 1651,
	"./Pictureds10.png": 1652,
	"./Pictureds2.png": 1653,
	"./Pictureds3.png": 1654,
	"./Pictureds4.png": 1655,
	"./Pictureds5.png": 1656,
	"./Pictureds6.png": 1657,
	"./Pictureds7.png": 1658,
	"./Pictureds8.png": 1659,
	"./Pictureds9.png": 1660,
	"./PwC_Repre_Illus_Iso_02_IoT_RGB.png": 1661,
	"./PwC_Repre_Illus_Iso_05_Chatbot_RGB.png": 1662,
	"./RealCase-en.png": 1663,
	"./RealCase-mobile-en.jpg": 964,
	"./RealCase-mobile-sc.jpg": 965,
	"./RealCase-sc.jpg": 966,
	"./RealCase.mobile.jpg": 967,
	"./RealCase.png": 1664,
	"./Realcase-socialMedia-en.png": 1665,
	"./Realcase-socialMedia-mobile-en.png": 1666,
	"./Realcase-socialMedia-mobile.jpg": 968,
	"./Realcase-socialMedia.jpg": 969,
	"./Shield.png": 484,
	"./Software-Downloading-icon1.png": 1667,
	"./Software-Downloading-icon2.png": 1668,
	"./Software-Downloading-icon3.png": 1669,
	"./Software-Downloading-icon4.png": 1670,
	"./Software-Downloading-img1.png": 1671,
	"./Software-Downloading-img2.png": 1672,
	"./Software-Downloading-img3.png": 1673,
	"./Software-Downloading-img4.png": 1674,
	"./a001-01.svg": 1675,
	"./a001-02.svg": 1676,
	"./a001-03.svg": 1677,
	"./a001-04.svg": 1678,
	"./a001-05.svg": 1679,
	"./a001-06.svg": 1680,
	"./a001-ransomware-01.png": 1681,
	"./a001-ransomware-02.png": 1682,
	"./a001-ransomware-03.png": 1683,
	"./a001-ransomware-04.png": 1684,
	"./a001-whatsapp-01.png": 1685,
	"./a001-whatsapp-02.png": 1686,
	"./a001-whatsapp-03.png": 1687,
	"./a004-a.jpg": 970,
	"./a004-b.jpg": 971,
	"./a004-example1-en.jpg": 972,
	"./a004-example1-sc.jpg": 973,
	"./a004-example1.jpg": 974,
	"./a004-example2.jpg": 975,
	"./a004-example3.jpg": 976,
	"./a004-mary-left.svg": 1688,
	"./a005-5.png": 1689,
	"./a005-6.png": 1690,
	"./a005-general2024.png": 1691,
	"./a006-a.png": 1692,
	"./a006-b.png": 1693,
	"./a006-c.png": 1694,
	"./a008-1.png": 1695,
	"./a008-1.svg": 1696,
	"./a008-2.png": 1697,
	"./a008-2.svg": 1698,
	"./a008-3.png": 1699,
	"./a008-3.svg": 1700,
	"./a008-4.png": 1701,
	"./a008-4.svg": 1702,
	"./a008-5.png": 1703,
	"./a008-5.svg": 1704,
	"./a008-6.svg": 1705,
	"./a008-7.svg": 1706,
	"./a008-A.svg": 1707,
	"./a008-B.svg": 1708,
	"./a008-C.svg": 1709,
	"./a008-D.svg": 1710,
	"./a008-tip.jpg": 977,
	"./a009-1.png": 1711,
	"./a009-1.svg": 1712,
	"./a009-2.png": 1713,
	"./a009-2.svg": 1714,
	"./a009-3.png": 1715,
	"./a009-3.svg": 1716,
	"./a009-4.png": 1717,
	"./a009-4.svg": 1718,
	"./a009-5.svg": 1719,
	"./a009-6.svg": 1720,
	"./a009-ransomware-01.svg": 1721,
	"./a009-ransomware-02.svg": 1722,
	"./a009-ransomware-03.svg": 1723,
	"./a009-ransomware-04.svg": 1724,
	"./a009-tip1.jpg": 978,
	"./a009-tip2.jpg": 979,
	"./a009-tip3.jpg": 980,
	"./a010-1.png": 1725,
	"./a010-2.png": 1726,
	"./a010-3.png": 1727,
	"./a010-4.png": 1728,
	"./a011-01.jpg": 981,
	"./a011-010.jpg": 982,
	"./a011-011.jpg": 983,
	"./a011-012.jpg": 984,
	"./a011-02.jpg": 985,
	"./a011-03.jpg": 986,
	"./a011-04.jpg": 987,
	"./a011-05.jpg": 988,
	"./a011-06.jpg": 989,
	"./a011-07.jpg": 990,
	"./a011-08.jpg": 991,
	"./a011-09.jpg": 992,
	"./a011-1.png": 1729,
	"./a011-1.svg": 1730,
	"./a011-2.png": 1731,
	"./a011-2.svg": 1732,
	"./a011-3.png": 1733,
	"./a011-3.svg": 1734,
	"./a011-4.png": 1735,
	"./a011-4.svg": 1736,
	"./a011-5.png": 1737,
	"./a011-5.svg": 1738,
	"./a011-6.png": 1739,
	"./a011-6.svg": 1740,
	"./a011-7.svg": 1741,
	"./a011-PPII-1.svg": 1742,
	"./a011-PPII-2.svg": 1743,
	"./a011-PPII-3.svg": 1744,
	"./a011-PPII-4.svg": 1745,
	"./a011-PPII-5.svg": 1746,
	"./a011-PPII-6.svg": 1747,
	"./a011-example1.jpg": 993,
	"./a011-example10.png": 1748,
	"./a011-example11_en.png": 1749,
	"./a011-example11_sc.png": 1750,
	"./a011-example11_tc.png": 1751,
	"./a011-example13_en.png": 1752,
	"./a011-example13_sc.png": 1753,
	"./a011-example13_tc.png": 1754,
	"./a011-example2.jpg": 994,
	"./a011-example3.jpg": 995,
	"./a011-example4.png": 1755,
	"./a011-example5.jpg": 996,
	"./a011-example6.jpg": 997,
	"./a011-example7.jpg": 998,
	"./a011-example8.jpg": 999,
	"./a011-example9.png": 1756,
	"./a011-fsi-01.svg": 1757,
	"./a011-fsi-02.svg": 1758,
	"./a011-fsi-03.svg": 1759,
	"./a011-fsi-04.svg": 1760,
	"./a011-fsi-05.svg": 1761,
	"./a011-fsi-06.svg": 1762,
	"./a011-fsi-07.svg": 1763,
	"./a011-fsi-08.svg": 1764,
	"./a011-fsi-09.svg": 1765,
	"./a011-fsi-10.svg": 1766,
	"./a011-general2024-example1.png": 1767,
	"./a011-general2024-example2.png": 1768,
	"./a011-general2024-example3.png": 1769,
	"./a011-general2024-example4.png": 1770,
	"./a011-market-1.svg": 1771,
	"./a011-market-2.svg": 1772,
	"./a011-market-3.svg": 1773,
	"./a011-market-4.svg": 1774,
	"./a011-market-5.svg": 1775,
	"./a011-market-6.svg": 1776,
	"./a011-startup-01.svg": 1777,
	"./a011-startup-02.svg": 1778,
	"./a011-startup-03.svg": 1779,
	"./a011-startup-04.svg": 1780,
	"./a011-startup-05.svg": 1781,
	"./a011-startup-06.svg": 1782,
	"./a011-startup-1.svg": 1783,
	"./a011-startup-2.svg": 1784,
	"./a011-startup-3.svg": 1785,
	"./a011-startup-4.svg": 1786,
	"./a011-startup-5.svg": 1787,
	"./a012-1.png": 1788,
	"./a012-1.svg": 1789,
	"./a012-10.png": 1790,
	"./a012-10.svg": 1791,
	"./a012-11.png": 1792,
	"./a012-12.png": 1793,
	"./a012-13.png": 1794,
	"./a012-14.png": 1795,
	"./a012-15.png": 1796,
	"./a012-2.png": 1797,
	"./a012-2.svg": 1798,
	"./a012-3.png": 1799,
	"./a012-3.svg": 1800,
	"./a012-4.png": 1801,
	"./a012-4.svg": 1802,
	"./a012-5.png": 1803,
	"./a012-5.svg": 1804,
	"./a012-6.png": 1805,
	"./a012-6.svg": 1806,
	"./a012-7.png": 1807,
	"./a012-7.svg": 1808,
	"./a012-8.png": 1809,
	"./a012-8.svg": 1810,
	"./a012-9.png": 1811,
	"./a012-9.svg": 1812,
	"./a012-market-1.svg": 1813,
	"./a012-market-10.svg": 1814,
	"./a012-market-2.svg": 1815,
	"./a012-market-3.svg": 1816,
	"./a012-market-4.svg": 1817,
	"./a012-market-5.svg": 1818,
	"./a012-market-6.svg": 1819,
	"./a012-market-7.svg": 1820,
	"./a012-market-8.svg": 1821,
	"./a012-market-9.svg": 1822,
	"./a012-market-line-1.svg": 1823,
	"./a012-market-line-10.svg": 1824,
	"./a012-market-line-2.svg": 1825,
	"./a012-market-line-3.svg": 1826,
	"./a012-market-line-4.svg": 1827,
	"./a012-market-line-5.svg": 1828,
	"./a012-market-line-6.svg": 1829,
	"./a012-market-line-7.svg": 1830,
	"./a012-market-line-8.svg": 1831,
	"./a012-market-line-9.svg": 1832,
	"./a013-1.png": 1833,
	"./a013-2.png": 1834,
	"./a013-3.png": 1835,
	"./a013-4.png": 1836,
	"./a013-a.png": 1837,
	"./a013-b.png": 1838,
	"./a013-c.png": 1839,
	"./a013-d.png": 1840,
	"./a014-long.svg": 1841,
	"./a014-longer.svg": 1842,
	"./a014.svg": 1843,
	"./a015-1.svg": 1844,
	"./a015-2.svg": 1845,
	"./a015-3.svg": 1846,
	"./a015-4.svg": 1847,
	"./a015-arrow.svg": 289,
	"./a016-1.jpg": 1000,
	"./a016-2.jpg": 1001,
	"./a016-3.jpg": 1002,
	"./a016-4.jpg": 1003,
	"./a016-4.png": 1848,
	"./a016-5.jpg": 1004,
	"./a016-5.png": 1849,
	"./a016-6.jpg": 1005,
	"./a016-6.png": 1850,
	"./a016-7.png": 1851,
	"./a016-8.png": 1852,
	"./a016-attention-market.svg": 290,
	"./a016-attention.svg": 291,
	"./a016-market-1.jpg": 1006,
	"./a016-market-2.jpg": 1007,
	"./a016-market-3.jpg": 1008,
	"./a016-market-4.jpg": 1009,
	"./a017-1.svg": 1853,
	"./a017-10.svg": 1854,
	"./a017-2.svg": 1855,
	"./a017-3.svg": 1856,
	"./a017-4.svg": 1857,
	"./a017-5.svg": 1858,
	"./a017-6.svg": 1859,
	"./a017-7.svg": 1860,
	"./a017-8.svg": 1861,
	"./a017-9.svg": 1862,
	"./a017-a.svg": 1863,
	"./a017-b.svg": 1864,
	"./a017-c.svg": 1865,
	"./a017-d.svg": 1866,
	"./a017-e.svg": 1867,
	"./a017-f.svg": 1868,
	"./a017-g.svg": 1869,
	"./a017-h.svg": 1870,
	"./a017-i.svg": 1871,
	"./a017-j.svg": 1872,
	"./a017-line1.svg": 1873,
	"./a017-line10.svg": 1874,
	"./a017-line2.svg": 1875,
	"./a017-line3.svg": 1876,
	"./a017-line4.svg": 1877,
	"./a017-line5.svg": 1878,
	"./a017-line6.svg": 1879,
	"./a017-line7.svg": 1880,
	"./a017-line8.svg": 1881,
	"./a017-line9.svg": 1882,
	"./a017-market-1.svg": 1883,
	"./a017-market-10.svg": 1884,
	"./a017-market-2.svg": 1885,
	"./a017-market-3.svg": 1886,
	"./a017-market-4.svg": 1887,
	"./a017-market-5.svg": 1888,
	"./a017-market-6.svg": 1889,
	"./a017-market-7.svg": 1890,
	"./a017-market-8.svg": 1891,
	"./a017-market-9.svg": 1892,
	"./a018-1.svg": 1893,
	"./a018-10.svg": 1894,
	"./a018-2.svg": 1895,
	"./a018-3.svg": 1896,
	"./a018-4.svg": 1897,
	"./a018-5.svg": 1898,
	"./a018-6.svg": 1899,
	"./a018-7.svg": 1900,
	"./a018-8.svg": 1901,
	"./a018-9.svg": 1902,
	"./a019-1.svg": 1903,
	"./a019-2.svg": 1904,
	"./a019-3.svg": 1905,
	"./a019-4.svg": 1906,
	"./a019-5.svg": 1907,
	"./a019-tip-en.jpg": 1010,
	"./a019-tip.jpg": 1011,
	"./a019.gif": 1908,
	"./a020-cs-1.svg": 1909,
	"./a020-cs-2.svg": 1910,
	"./a020-cs-3.svg": 1911,
	"./a020-cs-4.svg": 1912,
	"./a020-it-1.svg": 1913,
	"./a020-it-2.svg": 1914,
	"./a020-it-3.svg": 1915,
	"./a020-it-4.svg": 1916,
	"./a020-market-1.svg": 1917,
	"./a020-market-2.svg": 1918,
	"./a020-market-3.svg": 1919,
	"./a020-market-4.svg": 1920,
	"./a020-ngo-1.svg": 1921,
	"./a020-ngo-2.svg": 1922,
	"./a020-ngo-3.svg": 1923,
	"./a020-ngo-4.svg": 1924,
	"./a020-ngo-5.svg": 1925,
	"./a021-viewmore-en.jpg": 1012,
	"./a021-viewmore-en.png": 1926,
	"./a021-viewmore-fsi.jpg": 1013,
	"./a021-viewmore.jpg": 1014,
	"./a021-viewmore.png": 1927,
	"./a022-market.svg": 1928,
	"./a023-01.png": 1015,
	"./a023-02.png": 1016,
	"./a023-03.png": 1017,
	"./a023-04.png": 1018,
	"./a023-05.png": 1019,
	"./a023-06.png": 1020,
	"./a023-1.png": 1021,
	"./a023-2.png": 1022,
	"./a023-3.png": 1023,
	"./a023-4.png": 1024,
	"./a023-example1.png": 1025,
	"./a023-example2.png": 1026,
	"./a023-example3.png": 1027,
	"./a023-fsi1-short.png": 1028,
	"./a023-fsi2-short.png": 1029,
	"./a023-fsi3-short.png": 1030,
	"./a023-fsi4-short.png": 1031,
	"./a023-fsi5-short.png": 1032,
	"./a023-short1.jpg": 396,
	"./a023-short2.jpg": 397,
	"./a023-short3.jpg": 398,
	"./a023-short4.jpg": 399,
	"./a023-short5.jpg": 400,
	"./a023-short6.jpg": 401,
	"./a023-startup1-en-short.png": 1033,
	"./a023-startup1-en.png": 1034,
	"./a023-startup1-short.png": 1035,
	"./a023-startup1.png": 1036,
	"./a023-startup2-en-short.png": 1037,
	"./a023-startup2-en.png": 1038,
	"./a023-startup2-short.png": 1039,
	"./a023-startup2.png": 1040,
	"./a023-startup3-en-short.png": 1041,
	"./a023-startup3-en.png": 1042,
	"./a023-startup3-short.png": 1043,
	"./a023-startup3.png": 1044,
	"./a023-startup4-en-short.png": 1045,
	"./a023-startup4-en.png": 1046,
	"./a023-startup4-short.png": 1047,
	"./a023-startup4.png": 1048,
	"./a023-startup5-en-short.png": 1049,
	"./a023-startup5-en.png": 1050,
	"./a023-startup5-short.png": 1051,
	"./a023-startup5.png": 1052,
	"./a024-1.gif": 1929,
	"./a024-1.svg": 1930,
	"./a024-10.svg": 1931,
	"./a024-11.svg": 1932,
	"./a024-12.svg": 1933,
	"./a024-2.gif": 1934,
	"./a024-2.svg": 1935,
	"./a024-3.svg": 1936,
	"./a024-4.svg": 1937,
	"./a024-5.svg": 1938,
	"./a024-6.svg": 1939,
	"./a024-7.svg": 1940,
	"./a024-8.svg": 1941,
	"./a024-9.svg": 1942,
	"./a024-startup-1.svg": 1943,
	"./a024-startup-2.svg": 1944,
	"./a024-startup-3.svg": 1945,
	"./a024-startup-4.svg": 1946,
	"./a024-startup-5.svg": 1947,
	"./a024-startup-6.svg": 1948,
	"./a026-example1-en.png": 1949,
	"./a026-example1.jpg": 1053,
	"./a026-example2.jpg": 1054,
	"./a026-example3.jpg": 1055,
	"./a026-example4.jpg": 1056,
	"./a026-example5.jpg": 1057,
	"./a026-example6.jpg": 1058,
	"./a026-example7.jpg": 1059,
	"./a026-example8.png": 1950,
	"./a028-1.png": 1060,
	"./a028-1.svg": 1951,
	"./a028-2.png": 1061,
	"./a028-2.svg": 1952,
	"./a028-3.png": 1062,
	"./a028-3.svg": 1953,
	"./a028-4.png": 1063,
	"./a028-4.svg": 1954,
	"./a028-5.png": 1064,
	"./a028-5.svg": 1955,
	"./a028-6.png": 1065,
	"./a028-example1.jpg": 1066,
	"./a028-example2.jpg": 1067,
	"./a028-example3.jpg": 1068,
	"./a033.png": 1956,
	"./a036-1.svg": 1957,
	"./a036-2.svg": 1958,
	"./a036-3.svg": 1959,
	"./a036-4.svg": 1960,
	"./a036-5.svg": 1961,
	"./a037-1.svg": 1962,
	"./a037-10.svg": 1963,
	"./a037-2.svg": 1964,
	"./a037-3.svg": 1965,
	"./a037-4.svg": 1966,
	"./a037-5.svg": 1967,
	"./a037-6.svg": 1968,
	"./a037-7.svg": 1969,
	"./a037-8.svg": 1970,
	"./a037-9.svg": 1971,
	"./a037-IDNumber-08.png": 1972,
	"./a037-a.jpg": 1069,
	"./a037-address-02.png": 1973,
	"./a037-b.jpg": 1070,
	"./a037-biometricData-10.png": 1974,
	"./a037-c.jpg": 1071,
	"./a037-d.jpg": 1072,
	"./a037-dateofBirth-05.png": 1975,
	"./a037-driverLicenseNumber-06.png": 1976,
	"./a037-e.jpg": 1073,
	"./a037-emailAddress-04.png": 1977,
	"./a037-f.jpg": 1074,
	"./a037-financialAccount-09.png": 1978,
	"./a037-g.jpg": 1075,
	"./a037-h.jpg": 1076,
	"./a037-i.jpg": 1077,
	"./a037-j.jpg": 1078,
	"./a037-k.jpg": 1079,
	"./a037-l.jpg": 1080,
	"./a037-m.jpg": 1081,
	"./a037-n.jpg": 1082,
	"./a037-name-01.png": 1979,
	"./a037-passportNumber-07.png": 1980,
	"./a037-phoneNumber-03.png": 1981,
	"./a037-student-1-en.png": 1982,
	"./a037-student-1-sc.png": 1983,
	"./a037-student-1.png": 1984,
	"./a037-student-2.png": 1985,
	"./a037-student-t3-1.svg": 1986,
	"./a037-student-t3-10.svg": 1987,
	"./a037-student-t3-2.svg": 1988,
	"./a037-student-t3-3.svg": 1989,
	"./a037-student-t3-4.svg": 1990,
	"./a037-student-t3-5.svg": 1991,
	"./a037-student-t3-6.svg": 1992,
	"./a037-student-t3-7.svg": 1993,
	"./a037-student-t3-8.svg": 1994,
	"./a037-student-t3-9.svg": 1995,
	"./a037-student-t3-s3-1.svg": 1996,
	"./a037-student-t3-s3-10.svg": 1997,
	"./a037-student-t3-s3-2.svg": 1998,
	"./a037-student-t3-s3-3.svg": 1999,
	"./a037-student-t3-s3-4.svg": 2000,
	"./a037-student-t3-s3-5.svg": 2001,
	"./a037-student-t3-s3-6.svg": 2002,
	"./a037-student-t3-s3-7.svg": 2003,
	"./a037-student-t3-s3-8.svg": 2004,
	"./a037-student-t3-s3-9.svg": 2005,
	"./a038-1.svg": 2006,
	"./a038-2.svg": 2007,
	"./a038-3.svg": 2008,
	"./a038-4.svg": 2009,
	"./a038-5.svg": 2010,
	"./a038-6.svg": 2011,
	"./a038-7.svg": 2012,
	"./a041-1.png": 2013,
	"./a041-2.png": 2014,
	"./a041-3.png": 2015,
	"./a041-4.png": 2016,
	"./a041-5.png": 2017,
	"./a041-fsi1-bottom.png": 2018,
	"./a041-fsi1-top.png": 2019,
	"./a041-fsi2-bottom.png": 2020,
	"./a041-fsi2-top.png": 2021,
	"./a041-fsi3-bottom.png": 2022,
	"./a041-fsi3-top.png": 2023,
	"./a041-fsi4-bottom.png": 2024,
	"./a041-fsi4-top.png": 2025,
	"./a041-fsi5-bottom.png": 2026,
	"./a041-fsi5-top.png": 2027,
	"./a044-1.png": 2028,
	"./a044-2.png": 2029,
	"./a044-3.png": 2030,
	"./a044-4.png": 2031,
	"./a044-5.png": 2032,
	"./a044-6.png": 2033,
	"./a046-1.png": 2034,
	"./a046-2.png": 2035,
	"./a046-3.png": 2036,
	"./a046-4.png": 2037,
	"./a046-5.png": 2038,
	"./a046-6.png": 2039,
	"./a047-icon1.png": 2040,
	"./a047-icon2.png": 2041,
	"./a047-icon3.png": 2042,
	"./a047-icon4.png": 2043,
	"./a047-icon5.png": 2044,
	"./a047-icon6.png": 2045,
	"./a047-icon7.png": 2046,
	"./a047-icon8.png": 2047,
	"./a047-vector-purple.png": 2048,
	"./a047-vector-red.png": 2049,
	"./a047-vector.png": 2050,
	"./aiSecurity.png": 2051,
	"./aiSecurityRealcase-en.jpg": 1083,
	"./aiSecurityRealcase-mobile-en.jpg": 1084,
	"./aiSecurityRealcase-mobile.jpg": 1085,
	"./aiSecurityRealcase.jpg": 1086,
	"./animation-arrow.gif": 126,
	"./animation-arrow10.gif": 2052,
	"./animation-arrow11.gif": 2053,
	"./animation-arrow12.gif": 2054,
	"./animation-arrow13.gif": 2055,
	"./animation-arrow2.gif": 2056,
	"./animation-arrow20.gif": 2057,
	"./animation-arrow21.gif": 2058,
	"./animation-arrow26.gif": 2059,
	"./animation-arrow27.gif": 2060,
	"./animation-arrow28.gif": 2061,
	"./animation-arrow3.gif": 2062,
	"./animation-arrow4.gif": 2063,
	"./animation-arrow5.gif": 2064,
	"./animation-arrow6.gif": 2065,
	"./animation-arrow7.gif": 2066,
	"./animation-arrow8.gif": 2067,
	"./animation-arrow9.gif": 2068,
	"./animation-quiz.gif": 2069,
	"./animation004-1.png": 61,
	"./animation004-2.png": 2070,
	"./animation021-01.svg": 2071,
	"./animation021-02.svg": 2072,
	"./animation021-03.svg": 2073,
	"./animation021-04.svg": 2074,
	"./animation021-05.svg": 2075,
	"./animation021-06.svg": 2076,
	"./animation_password.gif": 2077,
	"./animation_password_en.gif": 2078,
	"./animation_point.gif": 4,
	"./arrow-left-long.png": 16,
	"./arrow-left.png": 153,
	"./arrow-right-long.png": 17,
	"./arrow-right.png": 154,
	"./arrow.png": 94,
	"./avater1.png": 2079,
	"./avater2.png": 2080,
	"./avater3.png": 2081,
	"./avater4.png": 2082,
	"./avater5.png": 2083,
	"./avater6.png": 59,
	"./avater7.png": 54,
	"./avater8.png": 2084,
	"./avater9.png": 2085,
	"./avaterStudent.svg": 2086,
	"./boss-right2.png": 2087,
	"./bp1.png": 2088,
	"./bp10.png": 2089,
	"./bp11.png": 2090,
	"./bp2.png": 2091,
	"./bp3.png": 2092,
	"./bp4.png": 2093,
	"./bp5.png": 2094,
	"./bp6.png": 2095,
	"./bp7.png": 2096,
	"./bp8.png": 2097,
	"./bp9.png": 2098,
	"./business-problem1-en.png": 2099,
	"./business-problem1-sc.png": 2100,
	"./business-problem1.png": 2101,
	"./business-problem2.gif": 2102,
	"./business-problem3.png": 2103,
	"./business-problem4-en.png": 2104,
	"./business-problem4.png": 2105,
	"./business-problem5-en.png": 2106,
	"./business-problem5-sc.png": 2107,
	"./business-problem5.png": 2108,
	"./c001-E-commerce-1.jpg": 1087,
	"./c001-E-commerce-2.jpg": 1088,
	"./c001-E-commerce-3.jpg": 1089,
	"./c001-E-commerce-4.jpg": 1090,
	"./c001-E-commerce-5.jpg": 1091,
	"./c001-E-commerce-6.jpg": 1092,
	"./c001-Picture1.jpg": 1093,
	"./c001-Picture2.jpg": 1094,
	"./c001-Picture3.jpg": 1095,
	"./c001-fsi-1.jpg": 1096,
	"./c001-fsi-2.jpg": 1097,
	"./c001-fsi-3.jpg": 1098,
	"./c001-fsi-4.jpg": 1099,
	"./c001-general2024-1.png": 2109,
	"./c001-general2024-2.png": 2110,
	"./c001-general2024-3.png": 2111,
	"./c001-general2024-4.png": 2112,
	"./c001-general2024-5.png": 2113,
	"./c001-general2024-6.png": 2114,
	"./c001-general2024-7.png": 2115,
	"./c001-general2024-8.png": 2116,
	"./c001-ngo-1.jpg": 1100,
	"./c001-ngo-2.jpg": 1101,
	"./c001-ngo-3.jpg": 1102,
	"./c001-ngo-4.jpg": 1103,
	"./c001-ngo-5.jpg": 1104,
	"./c001-student-1.jpg": 1105,
	"./c001-student-2.jpg": 1106,
	"./c001-student-3.jpg": 1107,
	"./c001-student-4.jpg": 1108,
	"./c001-student-5.jpg": 1109,
	"./c001-student-6.jpg": 1110,
	"./c001-student-7.jpg": 1111,
	"./c001-student-8.jpg": 1112,
	"./c002-1.png": 2117,
	"./c002-1.svg": 2118,
	"./c002-PPII-1.svg": 2119,
	"./c002-PPII-10.svg": 2120,
	"./c002-PPII-11.svg": 2121,
	"./c002-PPII-12.svg": 2122,
	"./c002-PPII-13.svg": 2123,
	"./c002-PPII-14.svg": 2124,
	"./c002-PPII-15.svg": 2125,
	"./c002-PPII-16.svg": 2126,
	"./c002-PPII-2.svg": 2127,
	"./c002-PPII-3.svg": 2128,
	"./c002-PPII-4.svg": 2129,
	"./c002-PPII-6.svg": 2130,
	"./c002-PPII-7.svg": 2131,
	"./c002-PPII-8.svg": 2132,
	"./c002-PPII-9.svg": 2133,
	"./c002-eCommerce.png": 2134,
	"./c002-example1.jpg": 1113,
	"./c002-general2024-example1.jpg": 1114,
	"./c002-pic.png": 2135,
	"./c002-whatsapp-01-en.png": 2136,
	"./c002-whatsapp-01.png": 2137,
	"./c002-whatsapp-02-en.png": 2138,
	"./c002-whatsapp-02.png": 2139,
	"./c003-man-left.png": 2140,
	"./c003-right-lady.png": 2141,
	"./c005-1.png": 2142,
	"./c005-10.png": 2143,
	"./c005-11.png": 2144,
	"./c005-12.png": 2145,
	"./c005-13.png": 2146,
	"./c005-2.png": 2147,
	"./c005-3.png": 2148,
	"./c005-4.png": 2149,
	"./c005-5.png": 2150,
	"./c005-6.png": 2151,
	"./c005-7.png": 2152,
	"./c005-8.png": 2153,
	"./c005-9.png": 2154,
	"./c005-arrow01.png": 485,
	"./c005-arrow02.png": 486,
	"./c005-whatsapp-01-en.png": 2155,
	"./c005-whatsapp-01.png": 2156,
	"./c005-whatsapp-02-en.png": 2157,
	"./c005-whatsapp-02.png": 2158,
	"./c005-whatsapp-03-en.png": 2159,
	"./c005-whatsapp-03.png": 2160,
	"./c006-1.jpg": 1115,
	"./c006-2.jpg": 1116,
	"./c006-3.jpg": 1117,
	"./c006-4.jpg": 1118,
	"./c006-5.gif": 2161,
	"./c006-5.jpg": 1119,
	"./c006-6.gif": 2162,
	"./c006-6.jpg": 1120,
	"./c006-a.jpg": 1121,
	"./c006-b.jpg": 1122,
	"./c006-b.png": 2163,
	"./c006-c.jpg": 1123,
	"./c006-c.png": 2164,
	"./c006-d.jpg": 1124,
	"./c007-1.jpg": 1125,
	"./c007-bg.jpg": 1126,
	"./c008-1.png": 2165,
	"./c008-2.png": 2166,
	"./c008-2.svg": 2167,
	"./c008-3.svg": 2168,
	"./c008-board.svg": 2169,
	"./c008-board1.svg": 2170,
	"./c010-1.png": 2171,
	"./c010-2.png": 2172,
	"./c010-3.png": 2173,
	"./c010-4.png": 2174,
	"./c013-1.png": 2175,
	"./c013-2.png": 2176,
	"./calendar.png": 292,
	"./can-do.png": 2177,
	"./can-do.svg": 2178,
	"./can-do1.png": 2179,
	"./can-not-do.png": 2180,
	"./ceritificate-background.png": 2181,
	"./cert/cert-E-commerce-HKIRC.jpg": 1127,
	"./cert/cert-E-commerce-consumer.jpg": 1128,
	"./cert/cert-E-commerce-cpttm.jpg": 1129,
	"./cert/cert-E-commerce-hkgcsmeaa.jpg": 402,
	"./cert/cert-customer-HKIRC.jpg": 1130,
	"./cert/cert-customer-consumer.jpg": 1131,
	"./cert/cert-customer-cpttm.jpg": 1132,
	"./cert/cert-customer-hkgcsmeaa.jpg": 403,
	"./cert/cert-finance-HKIRC-sc.jpg": 1133,
	"./cert/cert-finance-HKIRC.jpg": 1134,
	"./cert/cert-finance-consumer-sc.jpg": 1135,
	"./cert/cert-finance-consumer.jpg": 1136,
	"./cert/cert-finance-cpttm-sc.jpg": 1137,
	"./cert/cert-finance-cpttm.jpg": 1138,
	"./cert/cert-finance-hkgcsmeaa-sc.jpg": 404,
	"./cert/cert-finance-hkgcsmeaa.jpg": 405,
	"./cert/cert-fsi-HKIRC-sc.jpg": 1139,
	"./cert/cert-fsi-HKIRC.jpg": 1140,
	"./cert/cert-fsi-consumer-sc.jpg": 1141,
	"./cert/cert-fsi-consumer.jpg": 1142,
	"./cert/cert-fsi-cpttm-sc.jpg": 1143,
	"./cert/cert-fsi-cpttm.jpg": 1144,
	"./cert/cert-fsi-hkgcsmeaa-sc.jpg": 406,
	"./cert/cert-fsi-hkgcsmeaa.jpg": 407,
	"./cert/cert-general-staff-HKIRC-sc.jpg": 1145,
	"./cert/cert-general-staff-HKIRC.jpg": 1146,
	"./cert/cert-general-staff-a-HKIRC-sc.jpg": 1147,
	"./cert/cert-general-staff-a-HKIRC.jpg": 1148,
	"./cert/cert-general-staff-a-consumer-sc.jpg": 1149,
	"./cert/cert-general-staff-a-consumer.jpg": 1150,
	"./cert/cert-general-staff-a-cpttm-sc.jpg": 1151,
	"./cert/cert-general-staff-a-cpttm.jpg": 1152,
	"./cert/cert-general-staff-a-hkgcsmeaa-sc.jpg": 408,
	"./cert/cert-general-staff-a-hkgcsmeaa.jpg": 409,
	"./cert/cert-general-staff-consumer-sc.jpg": 1153,
	"./cert/cert-general-staff-consumer.jpg": 1154,
	"./cert/cert-general-staff-cpttm-sc.jpg": 1155,
	"./cert/cert-general-staff-cpttm.jpg": 1156,
	"./cert/cert-general-staff-hkgcsmeaa-sc.jpg": 410,
	"./cert/cert-general-staff-hkgcsmeaa.jpg": 411,
	"./cert/cert-general2024-HKIRC-sc.jpg": 1157,
	"./cert/cert-general2024-HKIRC.jpg": 1158,
	"./cert/cert-general2024-consumer-sc.jpg": 1159,
	"./cert/cert-general2024-consumer.jpg": 1160,
	"./cert/cert-general2024-cpttm-sc.jpg": 1161,
	"./cert/cert-general2024-cpttm.jpg": 1162,
	"./cert/cert-general2024-hkgcsmeaa-sc.jpg": 338,
	"./cert/cert-general2024-hkgcsmeaa.jpg": 339,
	"./cert/cert-hr-HKIRC.jpg": 1163,
	"./cert/cert-hr-consumer.jpg": 1164,
	"./cert/cert-hr-cpttm.jpg": 1165,
	"./cert/cert-hr-hkgcsmeaa.jpg": 412,
	"./cert/cert-it-HKIRC.jpg": 1166,
	"./cert/cert-it-consumer.jpg": 1167,
	"./cert/cert-it-cpttm.jpg": 1168,
	"./cert/cert-it-hkgcsmeaa.jpg": 413,
	"./cert/cert-market-HKIRC.jpg": 1169,
	"./cert/cert-market-consumer.jpg": 1170,
	"./cert/cert-market-cpttm.jpg": 1171,
	"./cert/cert-market-hkgcsmeaa.jpg": 414,
	"./cert/cert-ngo-HKIRC.jpg": 1172,
	"./cert/cert-ngo-consumer.jpg": 1173,
	"./cert/cert-ngo-cpttm.jpg": 1174,
	"./cert/cert-ngo-hkgcsmeaa.jpg": 415,
	"./cert/cert-senior-manager-HKIRC-sc.jpg": 1175,
	"./cert/cert-senior-manager-HKIRC.jpg": 1176,
	"./cert/cert-senior-manager-consumer-sc.jpg": 1177,
	"./cert/cert-senior-manager-consumer.jpg": 1178,
	"./cert/cert-senior-manager-cpttm-sc.jpg": 1179,
	"./cert/cert-senior-manager-cpttm.jpg": 1180,
	"./cert/cert-senior-manager-hkgcsmeaa-sc.jpg": 416,
	"./cert/cert-senior-manager-hkgcsmeaa.jpg": 417,
	"./cert/cert-startup-HKIRC.jpg": 1181,
	"./cert/cert-startup-consumer.jpg": 1182,
	"./cert/cert-startup-cpttm.jpg": 1183,
	"./cert/cert-startup-hkgcsmeaa.jpg": 418,
	"./cert/cert-student-HKIRC-sc.jpg": 1184,
	"./cert/cert-student-HKIRC.jpg": 1185,
	"./cert/cert-student-consumer-sc.jpg": 1186,
	"./cert/cert-student-consumer.jpg": 1187,
	"./cert/cert-student-cpttm-sc.jpg": 1188,
	"./cert/cert-student-cpttm.jpg": 1189,
	"./cert/cert-student-hkgcsmeaa-sc.jpg": 419,
	"./cert/cert-student-hkgcsmeaa.jpg": 420,
	"./chat.gif": 2182,
	"./civil/frameworks/grid1.png": 487,
	"./civil/frameworks/grid2.png": 488,
	"./civil/frameworks/grid3.png": 489,
	"./civil/frameworks/grid4.png": 490,
	"./civil/frameworks/illustrationBg.png": 491,
	"./civil/frameworks/illustrationBg1.png": 492,
	"./civil/frameworks/quiz-bg.png": 493,
	"./civil/frameworks/safe1.png": 494,
	"./civil/frameworks/safe2.png": 495,
	"./civil/frameworks/safe3.png": 496,
	"./civil/frameworks/safe4.png": 497,
	"./civil/frameworks/step-bg.png": 498,
	"./civil/start_right.png": 2183,
	"./component003-left.png": 40,
	"./component003-right.png": 41,
	"./component003Boss-left.png": 2184,
	"./component003Boss-right.png": 2185,
	"./component003Lady-right.png": 2186,
	"./component003Man-right.png": 2187,
	"./component003Student-right.svg": 2188,
	"./contacting.png": 2189,
	"./conversation-left.png": 31,
	"./conversation-right.png": 29,
	"./conversation-right2.png": 2190,
	"./courseLanding-PPII.png": 2191,
	"./courseLanding-aiSecurity.png": 2192,
	"./courseLanding-dataLeakage.png": 2193,
	"./courseLanding-ransomware-mobile.png": 2194,
	"./courseLanding-ransomware.png": 2195,
	"./courseLanding-socialMedia.png": 2196,
	"./courseLanding-whatsApp.png": 2197,
	"./courses/Finance.png": 2198,
	"./courses/Finance2.png": 2199,
	"./courses/GeneralStaff_Background.svg": 2200,
	"./courses/HR.png": 2201,
	"./courses/HotTopic_Background.svg": 2202,
	"./courses/IndustrySector_Background.svg": 2203,
	"./courses/JobPosition_Background.svg": 2204,
	"./courses/Manufacturing.png": 2205,
	"./courses/Ransomeware.png": 2206,
	"./courses/Retails.png": 2207,
	"./courses/Senior.png": 2208,
	"./courses/course1.png": 2209,
	"./courses/course10.png": 2210,
	"./courses/course8.png": 2211,
	"./courses/gf-topic1.png": 2212,
	"./cover.png": 2213,
	"./cs-a009-1.svg": 2214,
	"./cs-a009-2.svg": 2215,
	"./cs-a009-3.svg": 2216,
	"./cs-a009-4.svg": 2217,
	"./cs-a009-5.svg": 2218,
	"./cs-a009-6.svg": 2219,
	"./cs-a018-1.svg": 2220,
	"./cs-a018-10.svg": 2221,
	"./cs-a018-11.svg": 2222,
	"./cs-a018-2.svg": 2223,
	"./cs-a018-3.svg": 2224,
	"./cs-a018-4.svg": 2225,
	"./cs-a018-5.svg": 2226,
	"./cs-a018-6.svg": 2227,
	"./cs-a018-7.svg": 2228,
	"./cs-a018-8.svg": 2229,
	"./cs-a018-9.svg": 2230,
	"./cs-c001-Picture1.png": 2231,
	"./cs-c001-Picture2.png": 2232,
	"./cs-c001-Picture3.png": 2233,
	"./cs-c001-Picture4.png": 2234,
	"./cs-c003-boss-right.svg": 2235,
	"./cs-c003-right.svg": 2236,
	"./cs-gif1.gif": 2237,
	"./cs-gif2.gif": 2238,
	"./cs-gif3.gif": 2239,
	"./cs-gif4.gif": 2240,
	"./cs-welcome.svg": 2241,
	"./cyber-phishing1.png": 2242,
	"./cyber-phishing2.png": 2243,
	"./cyber-phishing3.png": 2244,
	"./cyber-phishing4.png": 2245,
	"./cybersecurity2026/close_icon.png": 2246,
	"./cybersecurity2026/error_bg.png": 2247,
	"./cybersecurity2026/finger.gif": 34,
	"./cybersecurity2026/quiz/correct_icon.png": 499,
	"./cybersecurity2026/quiz/error_icon.png": 500,
	"./cybersecurity2026/quiz/m_quiz_bg.png": 2248,
	"./cybersecurity2026/quiz/m_quiz_bg_1.png": 2249,
	"./cybersecurity2026/quiz/m_review_top_bg.png": 2250,
	"./cybersecurity2026/quiz/no_pass_bg.png": 2251,
	"./cybersecurity2026/quiz/no_pass_word_bg.png": 2252,
	"./cybersecurity2026/quiz/pass_bg.png": 2253,
	"./cybersecurity2026/quiz/pass_word_bg.png": 2254,
	"./cybersecurity2026/quiz/quiz_bg.png": 2255,
	"./cybersecurity2026/quiz/quiz_bg_1.png": 2256,
	"./cybersecurity2026/quiz/review_bg.png": 2257,
	"./cybersecurity2026/quiz/review_top_bg.png": 2258,
	"./cybersecurity2026/quiz/smile.png": 501,
	"./cybersecurity2026/quiz/upset.png": 502,
	"./cybersecurity2026/quiz_bg.png": 2259,
	"./cybersecurity2026/right_bg.png": 2260,
	"./cybersecurity2026/topic1000/bg1.png": 2261,
	"./cybersecurity2026/topic1000/bg2.png": 2262,
	"./cybersecurity2026/topic1000/bg3.png": 2263,
	"./cybersecurity2026/topic1000/bg4.png": 2264,
	"./cybersecurity2026/topic1000/bg5.png": 2265,
	"./cybersecurity2026/topic1000/bg6.png": 2266,
	"./cybersecurity2026/topic1000/bg7.png": 2267,
	"./cybersecurity2026/topic1000/date_bg.png": 2268,
	"./cybersecurity2026/topic1000/factor/factor_bubble.png": 2269,
	"./cybersecurity2026/topic1000/factor/factor_item_5.png": 2270,
	"./cybersecurity2026/topic1000/factor/factor_left_bg.png": 2271,
	"./cybersecurity2026/topic1000/factor/img.png": 2272,
	"./cybersecurity2026/topic1000/factor/img_1.png": 2273,
	"./cybersecurity2026/topic1000/factor/img_2.png": 2274,
	"./cybersecurity2026/topic1000/factor/img_3.png": 2275,
	"./cybersecurity2026/topic1000/factor/img_4.png": 2276,
	"./cybersecurity2026/topic1000/last_img.png": 503,
	"./cybersecurity2026/topic1000/light.png": 293,
	"./cybersecurity2026/topic1000/link1.png": 504,
	"./cybersecurity2026/topic1000/multiple/item1.png": 2277,
	"./cybersecurity2026/topic1000/multiple/item2.png": 2278,
	"./cybersecurity2026/topic1000/multiple/item3.png": 2279,
	"./cybersecurity2026/topic1000/multiple/m_multiple_bg.png": 2280,
	"./cybersecurity2026/topic1000/multiple/multiple_bg.png": 2281,
	"./cybersecurity2026/topic1000/person.png": 505,
	"./cybersecurity2026/topic1000/process/img.png": 2282,
	"./cybersecurity2026/topic1000/process/img_1.png": 2283,
	"./cybersecurity2026/topic1000/process/img_2.png": 2284,
	"./cybersecurity2026/topic1000/process/img_3.png": 2285,
	"./cybersecurity2026/topic1000/process/m_section1-process-bg.png": 2286,
	"./cybersecurity2026/topic1000/q_right_bg.png": 506,
	"./cybersecurity2026/topic1000/quiz_bg.png": 2287,
	"./cybersecurity2026/topic1000/quiz_bg_mobile.png": 2288,
	"./cybersecurity2026/topic1000/s3_bubble_left.png": 2289,
	"./cybersecurity2026/topic1000/s3_bubble_right.png": 2290,
	"./cybersecurity2026/topic1000/s3_item1.png": 2291,
	"./cybersecurity2026/topic1000/section-process-bg1.png": 2292,
	"./cybersecurity2026/topic1000/section-process-bg3.png": 2293,
	"./cybersecurity2026/topic1000/section1-process-bg.png": 2294,
	"./cybersecurity2026/topic1000/section1_tool.png": 2295,
	"./cybersecurity2026/topic1000/section2_1.png": 507,
	"./cybersecurity2026/topic1000/section3_1.png": 2296,
	"./cybersecurity2026/topic1000/section3_2.png": 2297,
	"./cybersecurity2026/topic1000/section3_bg.png": 2298,
	"./cybersecurity2026/topic1000/section3_bubble.png": 2299,
	"./cybersecurity2026/topic1000/section4_bubble_left.png": 2300,
	"./cybersecurity2026/topic1000/section4_bubble_right.png": 2301,
	"./cybersecurity2026/topic1000/section4_ex.png": 2302,
	"./cybersecurity2026/topic1000/section5_1.png": 2303,
	"./cybersecurity2026/topic1000/tab_bg.png": 2304,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_1.png": 2305,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_1_m.png": 2306,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_2.png": 2307,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_2_m.png": 2308,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_3.png": 2309,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_3_m.png": 2310,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_4.png": 2311,
	"./cybersecurity2026/topic1000/tool-pic/tool_item_4_m.png": 2312,
	"./cybersecurity2026/topic1000/tool_bubble.png": 2313,
	"./cybersecurity2026/topic1000/tools-bj-bottom.png": 508,
	"./cybersecurity2026/topic1000/tools-bj-top.png": 509,
	"./cybersecurity2026/topic1000/use/m_use_action_back_cz.png": 2314,
	"./cybersecurity2026/topic1000/use/m_use_action_back_hk.png": 2315,
	"./cybersecurity2026/topic1000/use/m_use_action_back_xw.png": 2316,
	"./cybersecurity2026/topic1000/use/m_use_action_back_zc.png": 2317,
	"./cybersecurity2026/topic1000/use/m_use_action_cz.png": 2318,
	"./cybersecurity2026/topic1000/use/m_use_action_hk.png": 2319,
	"./cybersecurity2026/topic1000/use/m_use_action_xw.png": 2320,
	"./cybersecurity2026/topic1000/use/m_use_action_zc.png": 2321,
	"./cybersecurity2026/topic1000/use/use_action_back_cz.png": 2322,
	"./cybersecurity2026/topic1000/use/use_action_back_hk.png": 2323,
	"./cybersecurity2026/topic1000/use/use_action_back_xw.png": 2324,
	"./cybersecurity2026/topic1000/use/use_action_back_zc.png": 2325,
	"./cybersecurity2026/topic1000/use/use_action_cz.png": 2326,
	"./cybersecurity2026/topic1000/use/use_action_hk.png": 2327,
	"./cybersecurity2026/topic1000/use/use_action_xw.png": 2328,
	"./cybersecurity2026/topic1000/use/use_action_zc.png": 2329,
	"./cybersecurity2026/topic1000/visit/header_bg.png": 2330,
	"./cybersecurity2026/topic1000/visit/icon1.png": 510,
	"./cybersecurity2026/topic1000/visit/icon2.png": 511,
	"./cybersecurity2026/topic1000/visit/icon3.png": 512,
	"./cybersecurity2026/topic1000/visit/img.png": 513,
	"./cybersecurity2026/topic1000/visit/img_1.png": 514,
	"./cybersecurity2026/topic1000/visit/img_2.png": 515,
	"./cybersecurity2026/topic1000/visit/img_3.png": 516,
	"./cybersecurity2026/topic1000/visit/img_4.png": 517,
	"./cybersecurity2026/topic1000/visit/img_5.png": 518,
	"./cybersecurity2026/topic1000/visit/img_6.png": 519,
	"./cybersecurity2026/topic1000/welcome_bg.png": 2331,
	"./cybersecurity2026/topic1000/welcome_bg_m.png": 2332,
	"./cybersecurity2026/topic1230pm/bg0.png": 2333,
	"./cybersecurity2026/topic1230pm/bg1.png": 2334,
	"./cybersecurity2026/topic1230pm/bg2.png": 2335,
	"./cybersecurity2026/topic1230pm/bg3.png": 2336,
	"./cybersecurity2026/topic1230pm/bg4.png": 2337,
	"./cybersecurity2026/topic1230pm/bg5.png": 2338,
	"./cybersecurity2026/topic1230pm/bg6.png": 2339,
	"./cybersecurity2026/topic1230pm/bg7.png": 2340,
	"./cybersecurity2026/topic1230pm/bg8.png": 2341,
	"./cybersecurity2026/topic1230pm/bg9.png": 2342,
	"./cybersecurity2026/topic1230pm/dialogue-left.png": 2343,
	"./cybersecurity2026/topic1230pm/dialogue-right.png": 2344,
	"./cybersecurity2026/topic1230pm/question.png": 2345,
	"./cybersecurity2026/topic1230pm/section0-img1.png": 520,
	"./cybersecurity2026/topic1230pm/section0-img2.png": 521,
	"./cybersecurity2026/topic1230pm/section1-bg1-h5.png": 2346,
	"./cybersecurity2026/topic1230pm/section1-bg1.png": 2347,
	"./cybersecurity2026/topic1230pm/section1-bg2-h5.png": 2348,
	"./cybersecurity2026/topic1230pm/section1-bg2.png": 2349,
	"./cybersecurity2026/topic1230pm/section1-bg3.png": 2350,
	"./cybersecurity2026/topic1230pm/section1-bg4.png": 2351,
	"./cybersecurity2026/topic1230pm/section1-img1.png": 2352,
	"./cybersecurity2026/topic1230pm/section1-img2.png": 2353,
	"./cybersecurity2026/topic1230pm/section1-item-1-h5.png": 2354,
	"./cybersecurity2026/topic1230pm/section1-item-1.png": 2355,
	"./cybersecurity2026/topic1230pm/section1-item-2-h5.png": 2356,
	"./cybersecurity2026/topic1230pm/section1-item-2.png": 2357,
	"./cybersecurity2026/topic1230pm/section1-item-3-h5.png": 2358,
	"./cybersecurity2026/topic1230pm/section1-item-3.png": 2359,
	"./cybersecurity2026/topic1230pm/section1-item-4-h5.png": 2360,
	"./cybersecurity2026/topic1230pm/section1-item-4.png": 2361,
	"./cybersecurity2026/topic1230pm/section2-bg.png": 2362,
	"./cybersecurity2026/topic1230pm/section2-bg1-h5.png": 2363,
	"./cybersecurity2026/topic1230pm/section2-bg1.png": 2364,
	"./cybersecurity2026/topic1230pm/section2-bg2-h5.png": 2365,
	"./cybersecurity2026/topic1230pm/section2-bg2.png": 2366,
	"./cybersecurity2026/topic1230pm/section2-bg3-h5.png": 2367,
	"./cybersecurity2026/topic1230pm/section2-bg3.png": 2368,
	"./cybersecurity2026/topic1230pm/section2-bg4-h5.png": 2369,
	"./cybersecurity2026/topic1230pm/section2-bg4.png": 2370,
	"./cybersecurity2026/topic1230pm/section2-bg5.png": 2371,
	"./cybersecurity2026/topic1230pm/section2-bg6.png": 2372,
	"./cybersecurity2026/topic1230pm/section2-guide-bar-h5.png": 2373,
	"./cybersecurity2026/topic1230pm/section2-guide-bar.png": 2374,
	"./cybersecurity2026/topic1230pm/section2-pic1.png": 522,
	"./cybersecurity2026/topic1230pm/section2-pic2.png": 523,
	"./cybersecurity2026/topic1230pm/section3-img1.png": 524,
	"./cybersecurity2026/topic1230pm/section3-img2.png": 525,
	"./cybersecurity2026/topic1230pm/section3-img3.png": 526,
	"./cybersecurity2026/topic1230pm/section3-num1.png": 527,
	"./cybersecurity2026/topic1230pm/section3-num2.png": 528,
	"./cybersecurity2026/topic1230pm/section3-num3.png": 529,
	"./cybersecurity2026/topic1230pm/section3-num4.png": 530,
	"./cybersecurity2026/topic1230pm/section3-num5.png": 531,
	"./cybersecurity2026/topic1230pm/section3-pic2.png": 532,
	"./cybersecurity2026/topic1230pm/section3-pic3.png": 2375,
	"./cybersecurity2026/topic1230pm/section3-pic4.png": 2376,
	"./cybersecurity2026/topic1230pm/section3-pic5.png": 2377,
	"./cybersecurity2026/topic1230pm/section3-pic6-h5.png": 2378,
	"./cybersecurity2026/topic1230pm/section3-pic6.png": 2379,
	"./cybersecurity2026/topic1230pm/section3-pic7.png": 2380,
	"./cybersecurity2026/topic1230pm/section3-pic8.png": 2381,
	"./cybersecurity2026/topic1230pm/section4-pic1.png": 2382,
	"./cybersecurity2026/topic1230pm/section4-pic2.png": 2383,
	"./cybersecurity2026/topic1230pm/section4-pic3.png": 533,
	"./cybersecurity2026/topic1230pm/section5-pic1-h5.png": 2384,
	"./cybersecurity2026/topic1230pm/section5-pic1.png": 2385,
	"./cybersecurity2026/topic1230pm/section5-pic2.png": 2386,
	"./cybersecurity2026/topic1230pm/section5-pic3.png": 2387,
	"./cybersecurity2026/topic1600/attentions/icon1.png": 534,
	"./cybersecurity2026/topic1600/attentions/icon2.png": 535,
	"./cybersecurity2026/topic1600/attentions/icon3.png": 536,
	"./cybersecurity2026/topic1600/attentions/icon4.png": 537,
	"./cybersecurity2026/topic1600/bg1.png": 2388,
	"./cybersecurity2026/topic1600/bg2.png": 2389,
	"./cybersecurity2026/topic1600/bg3.png": 2390,
	"./cybersecurity2026/topic1600/bg4.png": 2391,
	"./cybersecurity2026/topic1600/bg5.png": 2392,
	"./cybersecurity2026/topic1600/bg6.png": 2393,
	"./cybersecurity2026/topic1600/bg7.png": 2394,
	"./cybersecurity2026/topic1600/bg8.png": 2395,
	"./cybersecurity2026/topic1600/bg9.png": 2396,
	"./cybersecurity2026/topic1600/data-analysis.png": 538,
	"./cybersecurity2026/topic1600/guide_bg.png": 2397,
	"./cybersecurity2026/topic1600/guide_bg_top.png": 2398,
	"./cybersecurity2026/topic1600/link_1.png": 539,
	"./cybersecurity2026/topic1600/link_2.png": 540,
	"./cybersecurity2026/topic1600/link_3.png": 541,
	"./cybersecurity2026/topic1600/link_pic.png": 542,
	"./cybersecurity2026/topic1600/m_guide_bg_bottom.png": 2399,
	"./cybersecurity2026/topic1600/m_guide_bg_top.png": 2400,
	"./cybersecurity2026/topic1600/person.png": 543,
	"./cybersecurity2026/topic1600/quiz_bg.png": 2401,
	"./cybersecurity2026/topic1600/regression_bottom.png": 544,
	"./cybersecurity2026/topic1600/regression_top.png": 545,
	"./cybersecurity2026/topic1600/risk/img.png": 294,
	"./cybersecurity2026/topic1600/risk/img_1.png": 295,
	"./cybersecurity2026/topic1600/risk/img_2.png": 296,
	"./cybersecurity2026/topic1600/risk/img_3.png": 297,
	"./cybersecurity2026/topic1600/risk/img_4.png": 298,
	"./cybersecurity2026/topic1600/risk/img_5.png": 299,
	"./cybersecurity2026/topic1600/section1-bg-left.png": 2402,
	"./cybersecurity2026/topic1600/section1-bubble.png": 2403,
	"./cybersecurity2026/topic1600/section1_1.png": 546,
	"./cybersecurity2026/topic1600/section1_bubble.png": 2404,
	"./cybersecurity2026/topic1600/tools-bottom.png": 547,
	"./cybersecurity2026/topic1600/tools-top.png": 548,
	"./cybersecurity2026/topic1600/top-box-img.png": 549,
	"./cybersecurity2026/topic1600/trend-bubble.png": 2405,
	"./cybersecurity2026/topic1600/trend-top.png": 550,
	"./cybersecurity2026/topic1600/use/m_use_action_back1.png": 2406,
	"./cybersecurity2026/topic1600/use/m_use_action_back2.png": 2407,
	"./cybersecurity2026/topic1600/use/m_use_action_back3.png": 2408,
	"./cybersecurity2026/topic1600/use/m_use_action_back4.png": 2409,
	"./cybersecurity2026/topic1600/use/use_action_back1.png": 2410,
	"./cybersecurity2026/topic1600/use/use_action_back2.png": 2411,
	"./cybersecurity2026/topic1600/use/use_action_back3.png": 2412,
	"./cybersecurity2026/topic1600/use/use_action_back4.png": 2413,
	"./cybersecurity2026/topic900/background1.png": 2414,
	"./cybersecurity2026/topic900/background2.png": 2415,
	"./cybersecurity2026/topic900/background3.png": 2416,
	"./cybersecurity2026/topic900/background4.png": 2417,
	"./cybersecurity2026/topic900/bg-h5.png": 2418,
	"./cybersecurity2026/topic900/bubble-orange.png": 2419,
	"./cybersecurity2026/topic900/chatBg-h5.png": 2420,
	"./cybersecurity2026/topic900/chatBg.png": 2421,
	"./cybersecurity2026/topic900/section1-bg.png": 2422,
	"./cybersecurity2026/topic900/section1-header-Alert.png": 551,
	"./cybersecurity2026/topic900/section1-header-Edit.png": 552,
	"./cybersecurity2026/topic900/section1-header-Eye-off.png": 553,
	"./cybersecurity2026/topic900/section1-header-Hard-drive.png": 554,
	"./cybersecurity2026/topic900/section1-header-btn.png": 2423,
	"./cybersecurity2026/topic900/section1-header.png": 2424,
	"./cybersecurity2026/topic900/section1-img3.png": 2425,
	"./cybersecurity2026/topic900/section1-img4.png": 555,
	"./cybersecurity2026/topic900/section3-bg.png": 2426,
	"./cybersecurity2026/topic900/section3-icon1.png": 556,
	"./cybersecurity2026/topic900/section3-icon2.png": 557,
	"./cybersecurity2026/topic900/section3-img2.png": 558,
	"./cybersecurity2026/topic900/section4-bg.png": 2427,
	"./cybersecurity2026/topic900/section4-bg2-h5.png": 2428,
	"./cybersecurity2026/topic900/section4-bg2.png": 2429,
	"./cybersecurity2026/topic900/section4-pic1.png": 2430,
	"./cybersecurity2026/topic900/talk-down.png": 2431,
	"./cybersecurity2026/topic900/talk-up.png": 2432,
	"./cybersecurity2026/topic900/topic900_bg1.png": 559,
	"./cybersecurity2026/topic900/topic900_bg2.png": 560,
	"./cybersecurity2026/welcome/bubble.png": 2433,
	"./cybersecurity2026/welcome/folder.png": 2434,
	"./cybersecurity2026/welcome/four.png": 561,
	"./cybersecurity2026/welcome/highway.png": 2435,
	"./cybersecurity2026/welcome/line.png": 562,
	"./cybersecurity2026/welcome/m_highway.png": 2436,
	"./cybersecurity2026/welcome/m_welcome_bg.png": 2437,
	"./cybersecurity2026/welcome/person.png": 2438,
	"./cybersecurity2026/welcome/record.png": 2439,
	"./cybersecurity2026/welcome/three.png": 563,
	"./cybersecurity2026/welcome/triangle.png": 564,
	"./cybersecurity2026/welcome/two.png": 565,
	"./cybersecurity2026/welcome/welcome_bg.png": 2440,
	"./dataLeakage.png": 2441,
	"./dataLeakageRealcase-en.jpg": 1190,
	"./dataLeakageRealcase-mobile-en.jpg": 1191,
	"./dataLeakageRealcase-mobile.jpg": 1192,
	"./dataLeakageRealcase.jpg": 1193,
	"./desk-clean-icon1.png": 2442,
	"./desk-clean-icon2.png": 2443,
	"./desk-clean-icon3.png": 2444,
	"./desk-clean-icon4.png": 2445,
	"./desk-clean-img1.png": 2446,
	"./desk-clean-img2.png": 2447,
	"./desk-clean-img3.png": 2448,
	"./desk-clean-img4.png": 2449,
	"./desk-clean1.png": 2450,
	"./desk-clean2.png": 2451,
	"./desk-clean3.png": 2452,
	"./desk-clean4.png": 2453,
	"./desk-clean5.png": 2454,
	"./education/close_icon.png": 300,
	"./education/cybersecurity/arrow-right-circle.png": 566,
	"./education/cybersecurity/bg-light.png": 2455,
	"./education/cybersecurity/bg1.png": 2456,
	"./education/cybersecurity/bg2.png": 2457,
	"./education/cybersecurity/bg3.png": 2458,
	"./education/cybersecurity/bg4.png": 2459,
	"./education/cybersecurity/bg5.png": 2460,
	"./education/cybersecurity/bg6.png": 2461,
	"./education/cybersecurity/bg7.png": 2462,
	"./education/cybersecurity/chat-bg-h5.png": 2463,
	"./education/cybersecurity/chat-bg-pc.png": 2464,
	"./education/cybersecurity/chatBg.png": 2465,
	"./education/cybersecurity/h5-bg/case-study-center.png": 2466,
	"./education/cybersecurity/h5-bg/case-study-left.png": 2467,
	"./education/cybersecurity/h5-bg/case-study-right.png": 2468,
	"./education/cybersecurity/h5-bg/case-study-tips.png": 2469,
	"./education/cybersecurity/h5-bg/h5-bg1.png": 2470,
	"./education/cybersecurity/h5-bg/h5-bg2.png": 2471,
	"./education/cybersecurity/h5-bg/h5-bg3.png": 2472,
	"./education/cybersecurity/h5-bg/h5-bg4.png": 2473,
	"./education/cybersecurity/h5-bg/h5-bg5.png": 2474,
	"./education/cybersecurity/h5-bg/h5-bg6.png": 2475,
	"./education/cybersecurity/h5-bg/h5-bg7.png": 2476,
	"./education/cybersecurity/h5-bg/h5-bg8.png": 2477,
	"./education/cybersecurity/h5-bg/h5-pic-bg1.png": 2478,
	"./education/cybersecurity/h5-bg/process-bg.png": 2479,
	"./education/cybersecurity/h5-bg/section-process-1.png": 2480,
	"./education/cybersecurity/h5-bg/section-process-2.png": 2481,
	"./education/cybersecurity/h5-bg/section-process-3.png": 2482,
	"./education/cybersecurity/h5-bg/section-process-4.png": 2483,
	"./education/cybersecurity/icon-award.png": 567,
	"./education/cybersecurity/icon-book-open.png": 568,
	"./education/cybersecurity/icon-cast.png": 569,
	"./education/cybersecurity/icon-chevrons up.png": 570,
	"./education/cybersecurity/icon-clock.png": 571,
	"./education/cybersecurity/icon-command.png": 572,
	"./education/cybersecurity/message-bg.png": 2484,
	"./education/cybersecurity/message-bg.svg": 2485,
	"./education/cybersecurity/num-01.svg": 573,
	"./education/cybersecurity/num-02.svg": 574,
	"./education/cybersecurity/num-03.svg": 575,
	"./education/cybersecurity/num-04.svg": 576,
	"./education/cybersecurity/num-05.svg": 577,
	"./education/cybersecurity/num-icon-bg.png": 578,
	"./education/cybersecurity/num-icon1.svg": 579,
	"./education/cybersecurity/num-icon2.svg": 580,
	"./education/cybersecurity/num-icon3.svg": 581,
	"./education/cybersecurity/num-icon4.svg": 582,
	"./education/cybersecurity/num-icon5.svg": 583,
	"./education/cybersecurity/plan-bg.svg": 2486,
	"./education/cybersecurity/plan-pic-bg-h5.png": 2487,
	"./education/cybersecurity/plan-pic.png": 584,
	"./education/cybersecurity/question-bg.png": 2488,
	"./education/cybersecurity/section-process-bg1.png": 2489,
	"./education/cybersecurity/section-process-bg2.png": 2490,
	"./education/cybersecurity/section-process-bg3.png": 2491,
	"./education/cybersecurity/section-process-bg4.png": 2492,
	"./education/cybersecurity/section0-bg1.png": 585,
	"./education/cybersecurity/section0-bg2.png": 586,
	"./education/cybersecurity/section0-bg3.png": 2493,
	"./education/cybersecurity/section1-bg-h5.png": 2494,
	"./education/cybersecurity/section1-bg1.png": 587,
	"./education/cybersecurity/section1-bg2.svg": 2495,
	"./education/cybersecurity/section1-bg3-h5.png": 2496,
	"./education/cybersecurity/section1-bg3.svg": 2497,
	"./education/cybersecurity/section1-bg4.svg": 2498,
	"./education/cybersecurity/section1-measure1.svg": 2499,
	"./education/cybersecurity/section1-measure2.svg": 2500,
	"./education/cybersecurity/section1-measure3.svg": 2501,
	"./education/cybersecurity/section1-process-bg.png": 2502,
	"./education/cybersecurity/section1-process-bg1.png": 588,
	"./education/cybersecurity/section1-process-bg2.png": 589,
	"./education/cybersecurity/union.png": 2503,
	"./education/error_bg.png": 2504,
	"./education/ot/background-left.png": 2505,
	"./education/ot/bubble_bg.png": 2506,
	"./education/ot/guide_bg.png": 2507,
	"./education/ot/guide_bg_top.png": 2508,
	"./education/ot/guide_bg_y.png": 2509,
	"./education/ot/h5_guide_bg_top.png": 2510,
	"./education/ot/header-bg.png": 2511,
	"./education/ot/icon/icon1.png": 590,
	"./education/ot/icon/icon2.png": 591,
	"./education/ot/icon/icon3.png": 592,
	"./education/ot/icon/icon4.png": 593,
	"./education/ot/icon/icon5.png": 594,
	"./education/ot/icon/icon6.png": 595,
	"./education/ot/m_background-left.png": 2512,
	"./education/ot/ot_quiz_bg.png": 2513,
	"./education/ot/person.png": 596,
	"./education/ot/picture/img1.png": 597,
	"./education/ot/picture/img2.png": 598,
	"./education/ot/picture/img3.png": 599,
	"./education/ot/picture/img4.png": 600,
	"./education/ot/picture/img5.png": 601,
	"./education/ot/picture/img6.png": 602,
	"./education/ot/section0_bg.png": 2514,
	"./education/ot/section1_bg.png": 2515,
	"./education/ot/section2_bg.png": 2516,
	"./education/ot/section2_bg_1.png": 2517,
	"./education/ot/section2_bg_2.png": 2518,
	"./education/ot/tools-bj-bottom.png": 2519,
	"./education/ot/tools-bj-top.png": 2520,
	"./education/ot/welcome_bg_bubble.png": 2521,
	"./education/ptm/ai-bg.png": 2522,
	"./education/ptm/ai_left_bg.png": 603,
	"./education/ptm/ai_right_bg.png": 604,
	"./education/ptm/bubble/bubble1.png": 2523,
	"./education/ptm/bubble/bubble3.png": 2524,
	"./education/ptm/bubble/bubble4.png": 2525,
	"./education/ptm/bubble/bubble6.png": 2526,
	"./education/ptm/bubble/m_bubble1.png": 2527,
	"./education/ptm/bubble/m_bubble3.png": 2528,
	"./education/ptm/bubble/m_bubble4.png": 2529,
	"./education/ptm/bubble/m_bubble6.png": 2530,
	"./education/ptm/bubble_bg.png": 2531,
	"./education/ptm/factor/factor_bubble.png": 2532,
	"./education/ptm/factor/factor_item_1.png": 2533,
	"./education/ptm/factor/factor_item_2.png": 2534,
	"./education/ptm/factor/factor_item_3.png": 2535,
	"./education/ptm/factor/factor_item_4.png": 2536,
	"./education/ptm/factor/m_factor_item_1.png": 2537,
	"./education/ptm/factor/m_factor_item_2.png": 2538,
	"./education/ptm/factor/m_factor_item_3.png": 2539,
	"./education/ptm/factor/m_factor_item_4.png": 2540,
	"./education/ptm/factor_left_bg.png": 2541,
	"./education/ptm/factor_right_bg.png": 605,
	"./education/ptm/light.png": 301,
	"./education/ptm/m_ai_bg.png": 2542,
	"./education/ptm/m_bubble_bg.png": 2543,
	"./education/ptm/m_ptm_bg_2.png": 2544,
	"./education/ptm/m_welcome_bg_bubble.png": 2545,
	"./education/ptm/person.png": 606,
	"./education/ptm/practice_left_bg.png": 607,
	"./education/ptm/practice_right_bg.png": 608,
	"./education/ptm/practice_top_bg.png": 609,
	"./education/ptm/ptm_bg_1.png": 2546,
	"./education/ptm/ptm_bg_2.png": 2547,
	"./education/ptm/ptm_quiz_bg.png": 2548,
	"./education/ptm/q_right_bg.png": 610,
	"./education/ptm/use/m_use_action_back_cz.png": 2549,
	"./education/ptm/use/m_use_action_back_hk.png": 2550,
	"./education/ptm/use/m_use_action_back_xw.png": 2551,
	"./education/ptm/use/m_use_action_back_zc.png": 2552,
	"./education/ptm/use/m_use_action_cz.png": 2553,
	"./education/ptm/use/m_use_action_hk.png": 2554,
	"./education/ptm/use/m_use_action_xw.png": 2555,
	"./education/ptm/use/m_use_action_zc.png": 2556,
	"./education/ptm/use/use_action_back_cz.png": 2557,
	"./education/ptm/use/use_action_back_hk.png": 2558,
	"./education/ptm/use/use_action_back_xw.png": 2559,
	"./education/ptm/use/use_action_back_zc.png": 2560,
	"./education/ptm/use/use_action_cz.png": 2561,
	"./education/ptm/use/use_action_hk.png": 2562,
	"./education/ptm/use/use_action_xw.png": 2563,
	"./education/ptm/use/use_action_zc.png": 2564,
	"./education/ptm/welcome_bg.png": 2565,
	"./education/ptm/welcome_bg_bottom.png": 2566,
	"./education/ptm/welcome_bg_bubble.png": 2567,
	"./education/quiz/again_icon.png": 155,
	"./education/quiz/answer_left.png": 302,
	"./education/quiz/correct_icon.png": 611,
	"./education/quiz/downward_icon.png": 156,
	"./education/quiz/error_icon.png": 612,
	"./education/quiz/m_quiz_bg.png": 2568,
	"./education/quiz/m_quiz_bg_1.png": 2569,
	"./education/quiz/m_review_top_bg.png": 2570,
	"./education/quiz/no_pass_bg.png": 2571,
	"./education/quiz/no_pass_person.png": 157,
	"./education/quiz/no_pass_word_bg.png": 2572,
	"./education/quiz/pass_bg.png": 2573,
	"./education/quiz/pass_download.png": 158,
	"./education/quiz/pass_person.png": 159,
	"./education/quiz/pass_word_bg.png": 2574,
	"./education/quiz/quiz_bg.png": 2575,
	"./education/quiz/quiz_bg_1.png": 2576,
	"./education/quiz/review_bg.png": 2577,
	"./education/quiz/review_top_bg.png": 2578,
	"./education/quiz/smile.png": 613,
	"./education/quiz/upset.png": 614,
	"./education/quiz_bg.png": 2579,
	"./education/quiz_mask.png": 2580,
	"./education/right_bg.png": 2581,
	"./education/topic1000/Interacting1.png": 615,
	"./education/topic1000/Interacting2.png": 616,
	"./education/topic1000/arrow.svg": 2582,
	"./education/topic1000/bg1.png": 2583,
	"./education/topic1000/bg2.png": 2584,
	"./education/topic1000/bg3.png": 2585,
	"./education/topic1000/bg4.png": 2586,
	"./education/topic1000/bubble/bubble1.png": 2587,
	"./education/topic1000/bubble/bubble3.png": 2588,
	"./education/topic1000/bubble/bubble4.png": 2589,
	"./education/topic1000/bubble/bubble6.png": 2590,
	"./education/topic1000/case-study-h5.png": 2591,
	"./education/topic1000/h5-bg/collapse-bg.png": 2592,
	"./education/topic1000/h5-bg/h5-section2-bg1.png": 2593,
	"./education/topic1000/h5-bg/h5-section2-bg2.png": 2594,
	"./education/topic1000/h5-bg/h5-section2-bg3.png": 2595,
	"./education/topic1000/h5-bg/h5-section2-bg4.png": 2596,
	"./education/topic1000/link1-1.png": 617,
	"./education/topic1000/link1.png": 618,
	"./education/topic1000/link2.png": 619,
	"./education/topic1000/link3.png": 620,
	"./education/topic1000/panelData1.png": 621,
	"./education/topic1000/panelData2.png": 622,
	"./education/topic1000/panelData3.png": 623,
	"./education/topic1000/panelData4.jpg": 354,
	"./education/topic1000/panelData5.png": 624,
	"./education/topic1000/panelData6.jpg": 355,
	"./education/topic1000/phishing/bg.svg": 2597,
	"./education/topic1000/phishing/bubble_bg.svg": 625,
	"./education/topic1000/phishing/chatBg.png": 2598,
	"./education/topic1000/phishing/chatBg2.png": 2599,
	"./education/topic1000/phishing/icon1.svg": 626,
	"./education/topic1000/phishing/icon2.svg": 627,
	"./education/topic1000/phishing/icon3.svg": 628,
	"./education/topic1000/phishing/icon4.svg": 629,
	"./education/topic1000/phishing/icon5.svg": 630,
	"./education/topic1000/phishing/icon6.svg": 631,
	"./education/topic1000/phishing/pic1.svg": 2600,
	"./education/topic1000/phishing/questionBg.png": 2601,
	"./education/topic1000/phishing/tab1.svg": 2602,
	"./education/topic1000/phishing/tab2.svg": 2603,
	"./education/topic1000/phishing/title_bg.svg": 2604,
	"./education/topic1000/seciton3_icon.svg": 2605,
	"./education/topic1000/section1_footer_bg.png": 632,
	"./education/topic1000/section1_tool.png": 2606,
	"./education/topic1000/section1_tool1.png": 2607,
	"./education/topic1000/section1_tool_bubble.svg": 2608,
	"./education/topic1000/section3-bg-left.png": 2609,
	"./education/topic1000/section3_bg2.svg": 633,
	"./education/topic1000/section3_bg3.png": 634,
	"./education/topic1000/section3_bg4.png": 2610,
	"./education/topic1000/section3_bg5.png": 2611,
	"./education/topic1000/step-h5-bg.png": 2612,
	"./education/topic1000/tool-pic/tool-item-h5-bg1.png": 2613,
	"./education/topic1000/tool-pic/tool-item-h5-bg2.png": 2614,
	"./education/topic1000/tool-pic/tool-item-h5-bg3.png": 2615,
	"./education/topic1000/tool-pic/tool-item-h5-bg4.png": 2616,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg1.png": 2617,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg2.png": 2618,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg3.png": 2619,
	"./education/topic1000/tool-pic/tool-item-h5-blue-bg4.png": 2620,
	"./education/topic1000/tool-pic/tool_bubble.png": 2621,
	"./education/topic1000/tool-pic/tool_bubble_blue.png": 2622,
	"./education/topic1000/tool-pic/tool_item_1.png": 2623,
	"./education/topic1000/tool-pic/tool_item_2.png": 2624,
	"./education/topic1000/tool-pic/tool_item_3.png": 2625,
	"./education/topic1000/tool-pic/tool_item_4.png": 2626,
	"./education/topic1000/tool-pic/tool_item_blue1.png": 2627,
	"./education/topic1000/tool-pic/tool_item_blue2.png": 2628,
	"./education/topic1000/tool-pic/tool_item_blue3.png": 2629,
	"./education/topic1000/tool-pic/tool_item_blue4.png": 2630,
	"./education/topic900/bg-light.png": 2631,
	"./education/topic900/bg-orange.png": 2632,
	"./education/topic900/bg-priority.png": 2633,
	"./education/topic900/bg-white.png": 2634,
	"./education/topic900/bg1.png": 2635,
	"./education/topic900/bg2.png": 2636,
	"./education/topic900/bg3.png": 2637,
	"./education/topic900/bg4.png": 2638,
	"./education/topic900/chatBg.png": 2639,
	"./education/topic900/cyber-policy-bg.png": 2640,
	"./education/topic900/h5-bg/h5-section1-bg1.png": 2641,
	"./education/topic900/h5-bg/h5-section1-bg2.png": 2642,
	"./education/topic900/h5-bg/h5-section1-bg3.png": 2643,
	"./education/topic900/h5-bg/h5-section1-bg4.png": 2644,
	"./education/topic900/h5-bg/h5-section1-bg5.png": 2645,
	"./education/topic900/h5-bg/h5-section1-bg6.png": 2646,
	"./education/topic900/h5-bg/h5-section1-pic1.png": 2647,
	"./education/topic900/h5-bg/h5-section1-step.png": 2648,
	"./education/topic900/h5-bg/h5-section1-tip1.png": 2649,
	"./education/topic900/ot_quiz_bg.png": 2650,
	"./education/topic900/person.svg": 635,
	"./education/topic900/priority.png": 2651,
	"./education/topic900/priority_icon1.png": 303,
	"./education/topic900/priority_icon2.png": 304,
	"./education/topic900/priority_icon3.svg": 305,
	"./education/topic900/right-circle.png": 368,
	"./education/topic900/section1_1.png": 306,
	"./education/topic900/section1_2.png": 2652,
	"./education/topic900/section2_1.svg": 636,
	"./education/topic900/section2_2.png": 2653,
	"./education/topic900/section2_3.svg": 2654,
	"./education/topic900/section3_bg.svg": 2655,
	"./education/topic900/step.png": 2656,
	"./education/topic900/step1.png": 2657,
	"./education/topic900/step1.svg": 2658,
	"./education/topic900/step11.png": 637,
	"./education/topic900/step2.png": 2659,
	"./education/topic900/step2.svg": 2660,
	"./education/topic900/step22.png": 638,
	"./education/topic900/step3.png": 639,
	"./education/topic900/step3.svg": 2661,
	"./education/topic900/step4.png": 640,
	"./education/topic900/topic900_bg1.png": 641,
	"./education/topic900/topic900_bg2.png": 642,
	"./education/topic900/topic900_tip.svg": 2662,
	"./education/welcome/five.png": 643,
	"./education/welcome/folder.png": 2663,
	"./education/welcome/four.png": 644,
	"./education/welcome/highway.png": 2664,
	"./education/welcome/line.png": 645,
	"./education/welcome/m_five.png": 646,
	"./education/welcome/m_four.png": 647,
	"./education/welcome/m_highway.png": 2665,
	"./education/welcome/m_two.png": 648,
	"./education/welcome/m_welcome_bg.png": 2666,
	"./education/welcome/one.png": 649,
	"./education/welcome/person.png": 2667,
	"./education/welcome/record.png": 2668,
	"./education/welcome/three.png": 650,
	"./education/welcome/two.png": 651,
	"./education/welcome/vase.png": 2669,
	"./education/welcome/welcome_bg.png": 2670,
	"./equal-highlight.png": 652,
	"./equal.png": 653,
	"./filterArrow.svg": 307,
	"./finance-gif1.gif": 2671,
	"./finance-gif2.gif": 2672,
	"./finance-gif3.gif": 2673,
	"./finance-gif4.gif": 2674,
	"./finance-topic1.png": 2675,
	"./finance-topic2.png": 2676,
	"./finance-topic3.png": 2677,
	"./finance-topic4.png": 2678,
	"./finance/close_icon.png": 654,
	"./finance/error_bg.png": 2679,
	"./finance/img.png": 2680,
	"./finance/quiz/answer_left.png": 655,
	"./finance/quiz/correct_icon.png": 656,
	"./finance/quiz/error_icon.png": 657,
	"./finance/quiz/m_quiz_bg.png": 2681,
	"./finance/quiz/m_quiz_bg_1.png": 2682,
	"./finance/quiz/m_review_bg.png": 2683,
	"./finance/quiz/m_review_top_bg.png": 2684,
	"./finance/quiz/no_pass_bg.png": 2685,
	"./finance/quiz/no_pass_word_bg.png": 2686,
	"./finance/quiz/pass_bg.png": 2687,
	"./finance/quiz/pass_word_bg.png": 2688,
	"./finance/quiz/quiz_bg.png": 2689,
	"./finance/quiz/quiz_bg_1.png": 2690,
	"./finance/quiz/review_bg.png": 2691,
	"./finance/quiz/review_top_bg.png": 2692,
	"./finance/quiz/smile.png": 658,
	"./finance/quiz/upset.png": 659,
	"./finance/quiz_bg.png": 2693,
	"./finance/right_bg.png": 2694,
	"./finance/topic1100am/bg1.png": 2695,
	"./finance/topic1100am/bg2.png": 2696,
	"./finance/topic1100am/bg3.png": 2697,
	"./finance/topic1100am/bg4.png": 2698,
	"./finance/topic1100am/bg5.png": 2699,
	"./finance/topic1100am/bg6.png": 2700,
	"./finance/topic1100am/quiz_bg.png": 2701,
	"./finance/topic1100am/section1-arrow-down-circle.png": 660,
	"./finance/topic1100am/section1-bg-chat.png": 2702,
	"./finance/topic1100am/section1-bg.png": 661,
	"./finance/topic1100am/section1-bg1.png": 2703,
	"./finance/topic1100am/section1-img1.png": 662,
	"./finance/topic1100am/section1-img2.png": 663,
	"./finance/topic1100am/section1-img3.png": 664,
	"./finance/topic1100am/section1-img4.png": 665,
	"./finance/topic1100am/section1-img5.png": 666,
	"./finance/topic1100am/section2-2-img1.png": 667,
	"./finance/topic1100am/section2-3-img1.png": 2704,
	"./finance/topic1100am/section2-3-img2.png": 2705,
	"./finance/topic1100am/section2-4-img1.png": 2706,
	"./finance/topic1100am/section2-4-img2.png": 668,
	"./finance/topic1100am/section2-5-img1.png": 669,
	"./finance/topic1100am/section2-6-img1.png": 670,
	"./finance/topic1100am/section2-7-h5-num1.png": 2707,
	"./finance/topic1100am/section2-7-h5-num2.png": 2708,
	"./finance/topic1100am/section2-7-h5-num3.png": 2709,
	"./finance/topic1100am/section2-7-h5-num4.png": 2710,
	"./finance/topic1100am/section2-7-img1.png": 2711,
	"./finance/topic1100am/section2-7-num1.png": 2712,
	"./finance/topic1100am/section2-7-num2.png": 2713,
	"./finance/topic1100am/section2-7-num3.png": 2714,
	"./finance/topic1100am/section2-7-num4.png": 2715,
	"./finance/topic1100am/section2-icon1.png": 671,
	"./finance/topic1100am/section2-icon2.png": 672,
	"./finance/topic1100am/section2-icon3.png": 673,
	"./finance/topic1100am/section2-icon4.png": 674,
	"./finance/topic1100am/section2-icon5.png": 675,
	"./finance/topic1100am/section2-img1.png": 676,
	"./finance/topic1100am/section2-img2.png": 677,
	"./finance/topic1100am/topic0-bg0.png": 2716,
	"./finance/topic1100am/topic0-bg1.png": 678,
	"./finance/topic1100am/topic0-bg3.png": 679,
	"./finance/topic1100am/topic0-dialog.png": 2717,
	"./finance/topic1400/bg0_m.png": 2718,
	"./finance/topic1400/bg1.png": 2719,
	"./finance/topic1400/bg1_m.png": 2720,
	"./finance/topic1400/bg2.png": 2721,
	"./finance/topic1400/bg2_m.png": 2722,
	"./finance/topic1400/bg3.png": 2723,
	"./finance/topic1400/bg3_m.png": 2724,
	"./finance/topic1400/bg4.png": 2725,
	"./finance/topic1400/bg4_1_m.png": 2726,
	"./finance/topic1400/bg4_m.png": 2727,
	"./finance/topic1400/bg5.png": 2728,
	"./finance/topic1400/bg5_m.png": 2729,
	"./finance/topic1400/bubble.png": 2730,
	"./finance/topic1400/bubble_1_left.png": 2731,
	"./finance/topic1400/bubble_1_right.png": 2732,
	"./finance/topic1400/cycle_img.png": 2733,
	"./finance/topic1400/factor/section1-bg4.png": 2734,
	"./finance/topic1400/factor/section1-img2.png": 2735,
	"./finance/topic1400/importance/chatBg.png": 2736,
	"./finance/topic1400/importance/code1.png": 369,
	"./finance/topic1400/importance/code2.png": 680,
	"./finance/topic1400/importance/code3.png": 681,
	"./finance/topic1400/importance/code4.png": 682,
	"./finance/topic1400/importance/person.png": 683,
	"./finance/topic1400/m_section1-bg3.png": 2737,
	"./finance/topic1400/m_section5-pic1.png": 2738,
	"./finance/topic1400/person.png": 684,
	"./finance/topic1400/q_right_bg.png": 685,
	"./finance/topic1400/question.png": 2739,
	"./finance/topic1400/section1-bg3.png": 2740,
	"./finance/topic1400/section1-bg4.png": 2741,
	"./finance/topic1400/section1_1.png": 686,
	"./finance/topic1400/section1_bubble.png": 2742,
	"./finance/topic1400/section2-bg.png": 2743,
	"./finance/topic1400/section2-guide-bar-h5.png": 2744,
	"./finance/topic1400/section2-guide-bar.png": 2745,
	"./finance/topic1400/section2-img2.png": 2746,
	"./finance/topic1400/section5-pic1.png": 2747,
	"./finance/topic1400/tampering/code1.png": 370,
	"./finance/topic1400/tampering/code2.png": 687,
	"./finance/topic1400/tampering/code3.png": 688,
	"./finance/topic1400/tampering/code4.png": 689,
	"./finance/topic1600/bg1.png": 2748,
	"./finance/topic1600/bg2.png": 2749,
	"./finance/topic1600/bg3.png": 2750,
	"./finance/topic1600/bg4.png": 2751,
	"./finance/topic1600/bg5.png": 2752,
	"./finance/topic1600/bg6.png": 2753,
	"./finance/topic1600/bg7.png": 2754,
	"./finance/topic1600/bg8.png": 2755,
	"./finance/topic1600/icon1.png": 690,
	"./finance/topic1600/icon2.png": 691,
	"./finance/topic1600/icon3.png": 692,
	"./finance/topic1600/icon4.png": 693,
	"./finance/topic1600/icon5.png": 694,
	"./finance/topic1600/question-bg.png": 2756,
	"./finance/topic1600/section0-bg1.png": 695,
	"./finance/topic1600/section0-bg2.png": 696,
	"./finance/topic1600/section0-h5-bg1.png": 2757,
	"./finance/topic1600/section1-bg1.png": 697,
	"./finance/topic1600/section1-bg2.png": 698,
	"./finance/topic1600/section1-bg3.png": 699,
	"./finance/topic1600/section1-bg4.png": 700,
	"./finance/topic1600/section1-bg5.png": 2758,
	"./finance/topic1600/section1-bg6.png": 2759,
	"./finance/topic1600/section1-bg7.png": 2760,
	"./finance/topic1600/section1-bg8.png": 701,
	"./finance/topic1600/section1-icon1.png": 702,
	"./finance/topic1600/section1-icon2.png": 703,
	"./finance/topic1600/section1-icon3.png": 704,
	"./finance/topic1600/section1-icon4.png": 705,
	"./finance/topic1600/section1-icon5.png": 706,
	"./finance/topic1600/section2-bg1.png": 2761,
	"./finance/topic1600/section2-bg2.png": 2762,
	"./finance/topic1600/section2-bg5.png": 707,
	"./finance/topic1600/section3-bg1.png": 708,
	"./finance/topic1600/section3-bg2.png": 709,
	"./finance/topic1600/section3-bg3.png": 2763,
	"./finance/topic1600/section3-bg4.png": 2764,
	"./finance/topic1600/section3-icon1.png": 710,
	"./finance/topic1600/section3-icon2.png": 711,
	"./finance/topic1600/section3-icon3.png": 712,
	"./finance/topic1600/section3-icon4.png": 713,
	"./finance/topic1600/section3-icon5.png": 714,
	"./finance/topic1600/section3-icon6.png": 715,
	"./finance/topic900/bg0_m.png": 2765,
	"./finance/topic900/bg1.png": 2766,
	"./finance/topic900/bg1_m.png": 2767,
	"./finance/topic900/bg2.png": 2768,
	"./finance/topic900/bg2_m.png": 2769,
	"./finance/topic900/bg3.png": 2770,
	"./finance/topic900/bg3_1_m.png": 2771,
	"./finance/topic900/bg3_m.png": 2772,
	"./finance/topic900/bg4.png": 2773,
	"./finance/topic900/bg4_1_m.png": 2774,
	"./finance/topic900/bg4_m.png": 2775,
	"./finance/topic900/bg5.png": 2776,
	"./finance/topic900/bg5_m.png": 2777,
	"./finance/topic900/book.png": 308,
	"./finance/topic900/bubble.png": 2778,
	"./finance/topic900/bubble_1_left.png": 2779,
	"./finance/topic900/bubble_1_right.png": 2780,
	"./finance/topic900/chatBg-h5.png": 2781,
	"./finance/topic900/chatBg.png": 2782,
	"./finance/topic900/cycle_img.png": 2783,
	"./finance/topic900/cycle_list_left.png": 2784,
	"./finance/topic900/factor/factor_bubble.png": 2785,
	"./finance/topic900/factor/factor_item_1.png": 2786,
	"./finance/topic900/factor/factor_item_2.png": 2787,
	"./finance/topic900/factor/factor_item_3.png": 2788,
	"./finance/topic900/factor/factor_item_4.png": 2789,
	"./finance/topic900/factor/factor_item_5.png": 2790,
	"./finance/topic900/factor/factor_left_bg.png": 2791,
	"./finance/topic900/factor/m_factor_item_1.png": 2792,
	"./finance/topic900/factor/m_factor_item_2.png": 2793,
	"./finance/topic900/factor/m_factor_item_3.png": 2794,
	"./finance/topic900/factor/m_factor_item_4.png": 2795,
	"./finance/topic900/factor/m_factor_item_5.png": 2796,
	"./finance/topic900/light.png": 309,
	"./finance/topic900/link/link1.png": 371,
	"./finance/topic900/link/link2.png": 716,
	"./finance/topic900/link/link3.png": 717,
	"./finance/topic900/link/link4.png": 718,
	"./finance/topic900/link/play.png": 310,
	"./finance/topic900/m_middle_flow_bubble_bg.png": 2797,
	"./finance/topic900/m_middle_flow_person.png": 2798,
	"./finance/topic900/middle_flow_bubble_bg.png": 2799,
	"./finance/topic900/middle_flow_bubble_list.png": 2800,
	"./finance/topic900/middle_flow_person.png": 2801,
	"./finance/topic900/person.png": 719,
	"./finance/topic900/phishing.png": 720,
	"./finance/topic900/q_right_bg.png": 721,
	"./finance/topic900/quiz_bg.png": 2802,
	"./finance/topic900/section2_1.png": 2803,
	"./finance/topic900/section2_2.png": 2804,
	"./finance/topic900/section2_bubble.png": 2805,
	"./finance/topic900/section2_bubble_m.png": 2806,
	"./finance/topic900/section2_right.png": 722,
	"./finance/topic900/section3-bg.png": 2807,
	"./finance/topic900/section3-icon1.png": 723,
	"./finance/topic900/section3-icon2.png": 724,
	"./finance/topic900/section3_bubble.png": 2808,
	"./finance/topic900/tampering_img_1.png": 725,
	"./finance/topic900/tampering_img_2.png": 726,
	"./finance/topic900/tools-bj-bottom.png": 727,
	"./finance/topic900/tools-bj-top.png": 728,
	"./finance/topic900/use/m_use_action_back_cz.png": 2809,
	"./finance/topic900/use/m_use_action_back_hk.png": 2810,
	"./finance/topic900/use/m_use_action_back_xw.png": 2811,
	"./finance/topic900/use/m_use_action_back_zc.png": 2812,
	"./finance/topic900/use/m_use_action_cz.png": 2813,
	"./finance/topic900/use/m_use_action_hk.png": 2814,
	"./finance/topic900/use/m_use_action_xw.png": 2815,
	"./finance/topic900/use/m_use_action_zc.png": 2816,
	"./finance/topic900/use/use_action_back_cz.png": 2817,
	"./finance/topic900/use/use_action_back_hk.png": 2818,
	"./finance/topic900/use/use_action_back_xw.png": 2819,
	"./finance/topic900/use/use_action_back_zc.png": 2820,
	"./finance/topic900/use/use_action_cz.png": 2821,
	"./finance/topic900/use/use_action_hk.png": 2822,
	"./finance/topic900/use/use_action_xw.png": 2823,
	"./finance/topic900/use/use_action_zc.png": 2824,
	"./finance/topic900/welcome_bg.png": 2825,
	"./finance/welcome/highway.png": 2826,
	"./finance/welcome/line.png": 729,
	"./finance/welcome/m_highway.png": 2827,
	"./finance/welcome/m_welcome_bg.png": 2828,
	"./finance/welcome/person.png": 2829,
	"./finance/welcome/triangle.png": 730,
	"./finance/welcome/welcome_bg.png": 2830,
	"./flame-training.gif": 2831,
	"./fonts/02b3f97a-406d-43cb-885c-ba5233577cad.woff2": 2832,
	"./fonts/08b57253-2e0d-4c12-9c57-107f6c67bc49.woff2": 2833,
	"./fonts/08edde9d-c27b-4731-a27f-d6cd9b01cd06.woff": 2834,
	"./fonts/14d824a2-2a5c-4692-8e30-74f6e177b675.ttf": 2835,
	"./fonts/2025/1635950212302373.otf": 2836,
	"./fonts/2025/SourceHanSansCN-Bold.otf": 2837,
	"./fonts/2025/SourceHanSansCN-Bold.ttf": 2838,
	"./fonts/2025/SourceHanSansCN-ExtraLight.ttf": 2839,
	"./fonts/2025/SourceHanSansCN-Heavy.ttf": 2840,
	"./fonts/2025/SourceHanSansCN-Medium.otf": 2841,
	"./fonts/2025/SourceHanSansCN-Normal.otf": 2842,
	"./fonts/2025/SourceHanSansCN-Regular.otf": 2843,
	"./fonts/2025/SourceHanSansCN-Regular.ttf": 2844,
	"./fonts/22c6282d-e7aa-406b-89dc-5176916a9c44.ttf": 2845,
	"./fonts/240c57a0-fdce-440d-9ce3-85e0cb56f470.woff2": 2846,
	"./fonts/2a34f1f8-d701-4949-b12d-133c1c2636eb.woff": 2847,
	"./fonts/418e7417-47f3-40a1-8817-519a566f9d82.eot": 2848,
	"./fonts/4c21ab66-1566-4a85-b310-fbc649985f88.eot": 2849,
	"./fonts/4cc8f5da-4e24-4929-8efb-866ffcb1fe7e.eot": 2850,
	"./fonts/522972a6-5867-47ae-82fc-a7cf9bd5d4d4.eot": 2851,
	"./fonts/556d95c6-2352-4272-9422-83d53f66cfa3.ttf": 2852,
	"./fonts/5640036d-d549-4f16-b31e-87da78d9e832.eot": 2853,
	"./fonts/7802e576-2ffa-4f22-a409-534355fbea79.woff": 2854,
	"./fonts/7b415a05-784a-4a4c-8c94-67e9288312f5.woff": 2855,
	"./fonts/7d63ccf8-e0ae-4dee-ad4d-bbc798aa5803.woff2": 2856,
	"./fonts/800da3b0-675f-465f-892d-d76cecbdd5b1.woff2": 2857,
	"./fonts/8f4a1705-214a-4dd0-80b8-72252c37e688.ttf": 2858,
	"./fonts/922917a9-4ca8-4c0b-b1bb-417b6ff0210e.ttf": 2859,
	"./fonts/93ce67e5-64e3-4a99-99a3-545f20c5beec.woff2": 2860,
	"./fonts/96b3a113-3e18-46f9-b6e3-5bdee7288b20.woff": 2861,
	"./fonts/b2c1327f-ab3d-4230-93d7-eee8596e1498.woff": 2862,
	"./fonts/cad33bbd-bbf2-423b-98c5-51136c054e14.woff": 2863,
	"./fonts/cb0d1e8a-e111-4dbf-82c2-e948aba954c0.eot": 2864,
	"./fonts/da266c3a-a094-4adc-a81e-12f73609ba16.eot": 2865,
	"./fonts/f07c25ed-2d61-4e44-99ab-a0bc3ec67662.ttf": 2866,
	"./fonts/f9c5199e-a996-4c08-9042-1eb845bb7495.woff2": 2867,
	"./fonts/fdf10d5e-4ce0-45e5-a6c1-5eaff6cb1c11.ttf": 2868,
	"./fsi1.gif": 2869,
	"./fsi2.gif": 2870,
	"./fsi3.gif": 2871,
	"./fsi4.gif": 2872,
	"./fsiRealCase1-en.jpg": 1194,
	"./fsiRealCase1-mobile-en.jpg": 1195,
	"./fsiRealCase1-mobile-sc.jpg": 1196,
	"./fsiRealCase1-mobile.jpg": 1197,
	"./fsiRealCase1-sc.jpg": 1198,
	"./fsiRealCase1.jpg": 1199,
	"./fsiRealCase2-en-mobile.jpg": 1200,
	"./fsiRealCase2-en.jpg": 1201,
	"./fsiRealCase2-mobile-sc.jpg": 1202,
	"./fsiRealCase2-mobile.jpg": 1203,
	"./fsiRealCase2-sc.jpg": 1204,
	"./fsiRealCase2.jpg": 1205,
	"./general2024-1.gif": 2873,
	"./general2024-2.gif": 2874,
	"./general2024-3.gif": 2875,
	"./general2024-4.gif": 2876,
	"./general2024RealCase1-en-mobile.jpg": 1206,
	"./general2024RealCase1-en.jpg": 1207,
	"./general2024RealCase1-mobile-sc.jpg": 1208,
	"./general2024RealCase1-mobile.jpg": 1209,
	"./general2024RealCase1-sc.jpg": 1210,
	"./general2024RealCase1.jpg": 1211,
	"./globe.png": 311,
	"./hacker-using-laptop.gif": 2877,
	"./hacker1-en.png": 2878,
	"./hacker1.png": 2879,
	"./hacker2-en.png": 2880,
	"./hacker2.png": 2881,
	"./hacker3-en.png": 2882,
	"./hacker3.png": 2883,
	"./happy-emoji.png": 160,
	"./homelandingbg.png": 2884,
	"./icon-business.png": 312,
	"./icon-certificate.png": 313,
	"./icon-employee.png": 314,
	"./icon-training.png": 315,
	"./icon-vector1.png": 2885,
	"./icon-vector2.png": 2886,
	"./icon-vector3.png": 2887,
	"./icon-vector4.png": 2888,
	"./icon1.png": 2889,
	"./icon10.png": 2890,
	"./icon11.png": 2891,
	"./icon12.png": 2892,
	"./icon2.png": 2893,
	"./icon3.png": 2894,
	"./icon4.png": 2895,
	"./icon5.png": 2896,
	"./icon6.png": 2897,
	"./icon7.png": 2898,
	"./icon8.png": 2899,
	"./icon9.png": 2900,
	"./info-forgot-password-in.gif": 2901,
	"./info-journey-en.gif": 2902,
	"./info-journey.gif": 2903,
	"./info-new-mail.gif": 2904,
	"./info-password-security.gif": 2905,
	"./info-wifi.gif": 2906,
	"./it-gif1.gif": 2907,
	"./it-gif2.gif": 2908,
	"./it-gif3.gif": 2909,
	"./it-gif4.gif": 2910,
	"./it900-a031-en.jpg": 1212,
	"./it900-a031.jpg": 1213,
	"./it900-a32-1.jpg": 1214,
	"./it900-a32-2.jpg": 1215,
	"./it900-a32-3.jpg": 1216,
	"./it930-a033-1.jpg": 1217,
	"./it930-a033-2.jpg": 1218,
	"./it930-a033-3.jpg": 1219,
	"./it930-a033-4.jpg": 1220,
	"./it930-a033-5-en.jpg": 1221,
	"./it930-a033-5.jpg": 1222,
	"./lady-right-01.png": 2911,
	"./lady-right.jpg": 1223,
	"./lady-right.png": 2912,
	"./landingbg.png": 2913,
	"./logo.png": 2914,
	"./logo/consumer.png": 2915,
	"./logo/cpttm.png": 2916,
	"./logo/hkgcsmeaa.png": 2917,
	"./logo/logo.png": 2918,
	"./man-left-2.svg": 2919,
	"./man-right-2.png": 2920,
	"./man-right.jpg": 1224,
	"./man-right2.png": 2921,
	"./man.jpg": 1225,
	"./market-gif1.gif": 2922,
	"./market-gif2.gif": 2923,
	"./market-gif3.gif": 2924,
	"./market-gif4.gif": 2925,
	"./market-notpass.png": 731,
	"./market-quiz-info.png": 732,
	"./meeting.png": 2926,
	"./news-en.png": 2927,
	"./news-mobile-en.jpg": 1226,
	"./news-mobile-sc.jpg": 1227,
	"./news-mobile.jpg": 1228,
	"./news-sc.jpg": 1229,
	"./news.jpg": 1230,
	"./news.png": 2928,
	"./next-icon.svg": 733,
	"./ngo-a035-1.jpg": 1231,
	"./ngo-a035-2.jpg": 1232,
	"./ngo-a035-3.jpg": 1233,
	"./ngo-a035-4.jpg": 1234,
	"./ngo-a036-example-en.png": 2929,
	"./ngo-a036-example.jpg": 1235,
	"./ngo-gif1.gif": 2930,
	"./ngo-gif2.gif": 2931,
	"./ngo-gif3.gif": 2932,
	"./ngo-gif4.gif": 2933,
	"./notpass.png": 2934,
	"./office-risk1.png": 2935,
	"./office-risk2.png": 2936,
	"./office-risk3.png": 2937,
	"./office-risk4.png": 2938,
	"./office-risk5.png": 2939,
	"./org-brand1.png": 2940,
	"./ornament.png": 175,
	"./p-completed.svg": 2941,
	"./p-notstart.svg": 2942,
	"./p-onprogress-B.jpg": 1236,
	"./p-onprogress-E-commerce.png": 2943,
	"./p-onprogress-b.png": 2944,
	"./p-onprogress-cs.png": 2945,
	"./p-onprogress-fsi.png": 2946,
	"./p-onprogress-g.png": 2947,
	"./p-onprogress-general2024.png": 2948,
	"./p-onprogress-it.png": 2949,
	"./p-onprogress-ngo.png": 2950,
	"./p-onprogress-startup.png": 2951,
	"./p-onprogress-student.png": 2952,
	"./p-onprogress.svg": 2953,
	"./p9801.png": 372,
	"./pass.png": 734,
	"./phishing-indentify1.png": 2954,
	"./phishing-indentify2.png": 2955,
	"./phishing-indentify3.png": 2956,
	"./phishing-indentify4-en.png": 2957,
	"./phishing-indentify4.png": 2958,
	"./phishing-indentify5.png": 2959,
	"./phishing-indentify6.png": 2960,
	"./phishing1.png": 2961,
	"./phishing2.png": 2962,
	"./phishing3.png": 2963,
	"./phishing4.png": 2964,
	"./phishingicon1.png": 2965,
	"./phishingicon2.png": 2966,
	"./phishingicon3.png": 2967,
	"./phishingicon4.png": 2968,
	"./plus.png": 135,
	"./popover-red.png": 2969,
	"./popover.png": 2970,
	"./popup1.png": 2971,
	"./prev-icon.svg": 2972,
	"./pwc-logo-dark.png": 2973,
	"./pwc-logo-dark.svg": 2974,
	"./pwc-logo-white.png": 2975,
	"./pwc-logo-white.svg": 2976,
	"./pwc-logo.png": 2977,
	"./pwc-logo.svg": 2978,
	"./quiz-icon.png": 316,
	"./quiz-info.png": 2979,
	"./quizbg.png": 2980,
	"./ransomewareRealcase-en.png": 2981,
	"./ransomewareRealcase-mobile-en.png": 2982,
	"./ransomewareRealcase-mobile.png": 2983,
	"./ransomewareRealcase.png": 2984,
	"./ransomware.png": 2985,
	"./results1.png": 2986,
	"./results2.png": 2987,
	"./results3.png": 2988,
	"./results4.png": 2989,
	"./s3-001.png": 2990,
	"./s3-002.png": 2991,
	"./s3-003.png": 2992,
	"./s3-004.jpg": 1237,
	"./s3-005.jpg": 1238,
	"./s3-006.jpg": 1239,
	"./s3-007.jpg": 1240,
	"./s3-008.jpg": 1241,
	"./sample.png": 2993,
	"./secure-warning-bg.png": 2994,
	"./secure-warning1.png": 2995,
	"./secure-warning2.png": 2996,
	"./senior-sample1.png": 2997,
	"./senior-sample10.png": 2998,
	"./senior-sample2.png": 2999,
	"./senior-sample3-sc.png": 3000,
	"./senior-sample3.png": 3001,
	"./senior-sample4.png": 3002,
	"./senior-sample5.png": 3003,
	"./senior-sample6.png": 3004,
	"./senior-sample7.png": 3005,
	"./senior-sample8.png": 3006,
	"./senior-sample9.png": 3007,
	"./service.png": 735,
	"./small-icon1.png": 3008,
	"./small-icon10.png": 3009,
	"./small-icon2.png": 3010,
	"./small-icon3.png": 3011,
	"./small-icon4.png": 3012,
	"./small-icon5.png": 3013,
	"./small-icon6.png": 3014,
	"./small-icon7.png": 3015,
	"./small-icon8.png": 3016,
	"./small-icon9.png": 3017,
	"./sme/arrow_next.png": 3018,
	"./sme/component/bubble_1_left.png": 3019,
	"./sme/component/bubble_1_right.png": 3020,
	"./sme/component/bubble_square_left.png": 3021,
	"./sme/component/bubble_square_right.png": 3022,
	"./sme/component/circle-active.png": 736,
	"./sme/component/circle-inactive.png": 737,
	"./sme/component/colon_icon.png": 738,
	"./sme/component/correct_icon.png": 739,
	"./sme/component/error_icon.png": 161,
	"./sme/component/example_top.png": 3023,
	"./sme/component/frame_bg.png": 3024,
	"./sme/component/icon/Activity.png": 740,
	"./sme/component/icon/ActivityInactive.png": 741,
	"./sme/component/icon/FolderPlus.png": 742,
	"./sme/component/icon/FolderPlusnactive.png": 743,
	"./sme/component/icon/Settings.png": 744,
	"./sme/component/icon/SettingsInactive.png": 745,
	"./sme/component/icon/Shield.png": 746,
	"./sme/component/icon/Shieldnactive.png": 747,
	"./sme/component/m_real-case-bg.png": 3025,
	"./sme/component/real-case-bg.png": 3026,
	"./sme/component/step-bg.png": 3027,
	"./sme/component/triangle-active.png": 748,
	"./sme/component/triangle-inactive.png": 749,
	"./sme/ics/attacker/card_bg_1.png": 162,
	"./sme/ics/attacker/card_bg_2.png": 163,
	"./sme/ics/attacker/card_bg_3.png": 164,
	"./sme/ics/attacker/card_bg_4.png": 165,
	"./sme/ics/attacker/card_bg_5.png": 166,
	"./sme/ics/carousel_card_bg.png": 3028,
	"./sme/ics/case_top_bg.png": 750,
	"./sme/ics/quiz_people.png": 751,
	"./sme/ics/target_bg.png": 752,
	"./sme/ics/title_icon.png": 753,
	"./sme/psa/quiz_people.png": 754,
	"./sme/psa/title_icon.png": 755,
	"./sme/quiz/downward_icon.png": 167,
	"./sme/quiz/mistakes_bg.png": 3029,
	"./sme/quiz/mistakes_icon.png": 756,
	"./sme/quiz/not_pass.png": 757,
	"./sme/quiz/pass.png": 758,
	"./sme/quiz/pass_upset.png": 759,
	"./sme/quiz/pen-tool.png": 760,
	"./sme/quiz/quiz.png": 761,
	"./sme/quiz/scoreRating_no_pass_bg.png": 168,
	"./sme/quiz/scoreRating_pass_bg.png": 762,
	"./sme/quiz/upset.png": 763,
	"./sme/sso/AiFace.gif": 317,
	"./sme/sso/FourPartIllustration.png": 318,
	"./sme/sso/icon1.png": 764,
	"./sme/sso/icon2.png": 765,
	"./sme/sso/icon3.png": 766,
	"./sme/sso/icon4.png": 767,
	"./sme/sso/title_icon.png": 768,
	"./sme/sso/topic2-quiz-bg.png": 769,
	"./sme/start_right.png": 3030,
	"./sme/tpv/FourPartIllustration.png": 770,
	"./sme/tpv/quiz-bg.png": 3031,
	"./sme/tpv/sace-bg.png": 771,
	"./sme/tpv/section1-bg.png": 772,
	"./sme/tpv/section3-bg.png": 3032,
	"./sme/tpv/title_icon.png": 773,
	"./sme/tpv/topic2-quiz-bg.png": 774,
	"./sme/uats/FourPartIllustration.png": 775,
	"./sme/uats/case_top_bg.png": 776,
	"./sme/uats/do_circle.png": 777,
	"./sme/uats/dont_circle.png": 778,
	"./sme/uats/quiz_bg.png": 779,
	"./sme/uats/robot.png": 780,
	"./sme/uats/title_icon.svg": 781,
	"./social-media-bg-g.png": 3033,
	"./social-media-bg.png": 3034,
	"./social-media.gif": 95,
	"./socialMedia.png": 3035,
	"./sponsor-logo/1.png": 3036,
	"./sponsor-logo/10.png": 3037,
	"./sponsor-logo/11.png": 3038,
	"./sponsor-logo/12.png": 3039,
	"./sponsor-logo/13.png": 3040,
	"./sponsor-logo/14.png": 3041,
	"./sponsor-logo/15.png": 3042,
	"./sponsor-logo/16.png": 3043,
	"./sponsor-logo/17.png": 3044,
	"./sponsor-logo/18.png": 3045,
	"./sponsor-logo/19.png": 3046,
	"./sponsor-logo/2.png": 3047,
	"./sponsor-logo/20.png": 3048,
	"./sponsor-logo/21.png": 3049,
	"./sponsor-logo/22.png": 3050,
	"./sponsor-logo/23.png": 3051,
	"./sponsor-logo/24.png": 3052,
	"./sponsor-logo/25.png": 3053,
	"./sponsor-logo/26.png": 3054,
	"./sponsor-logo/27.png": 3055,
	"./sponsor-logo/28.png": 3056,
	"./sponsor-logo/29.png": 3057,
	"./sponsor-logo/3.png": 3058,
	"./sponsor-logo/30.png": 3059,
	"./sponsor-logo/4.png": 3060,
	"./sponsor-logo/5.png": 3061,
	"./sponsor-logo/6.png": 3062,
	"./sponsor-logo/7.png": 3063,
	"./sponsor-logo/8.png": 3064,
	"./sponsor-logo/9.png": 3065,
	"./sponsor-logo/more1.png": 3066,
	"./startup1.gif": 3067,
	"./startup2.gif": 3068,
	"./startup3.gif": 3069,
	"./startup4.gif": 3070,
	"./startupRealCase1-en.jpg": 1242,
	"./startupRealCase1-mobile-en.jpg": 1243,
	"./startupRealCase1-mobile.jpg": 1244,
	"./startupRealCase1.jpg": 1245,
	"./startupRealCase2-en.jpg": 1246,
	"./startupRealCase2-mobile-en.jpg": 1247,
	"./startupRealCase2-mobile.jpg": 1248,
	"./startupRealCase2.jpg": 1249,
	"./step-c-1.png": 62,
	"./step-c-2.png": 63,
	"./step-c-3.png": 64,
	"./step-i-1.png": 3071,
	"./step-i-2.png": 3072,
	"./step-i-3.png": 3073,
	"./step-i-4.png": 3074,
	"./student-training/AIns/do.png": 782,
	"./student-training/AIns/dont.png": 783,
	"./student-training/AIns/icon.png": 784,
	"./student-training/AIns/img-step1.png": 785,
	"./student-training/AIns/img-step2.png": 786,
	"./student-training/AIns/img-step3.png": 787,
	"./student-training/AIns/img-step4.png": 788,
	"./student-training/AIns/img1.png": 789,
	"./student-training/AIns/img2.png": 790,
	"./student-training/AIns/quiz-bg.png": 791,
	"./student-training/AIns/step1.png": 792,
	"./student-training/AIns/step2.png": 793,
	"./student-training/AIns/step3.png": 794,
	"./student-training/AIns/step4.png": 795,
	"./student-training/component/arrow-icon1.png": 796,
	"./student-training/component/arrow-icon2.png": 797,
	"./student-training/component/correct_icon.png": 319,
	"./student-training/component/m_real-case-bg.png": 3075,
	"./student-training/component/quiz-bg.png": 169,
	"./student-training/ctis/icon.png": 798,
	"./student-training/ctis/img1.png": 799,
	"./student-training/ctis/img2.png": 800,
	"./student-training/ctis/img3.png": 801,
	"./student-training/ctis/quiz-bg.png": 802,
	"./student-training/ctis/step1.png": 803,
	"./student-training/ctis/step2.png": 804,
	"./student-training/ctis/step3.png": 805,
	"./student-training/ctis/step4.png": 806,
	"./student-training/pyde/avatar1.png": 807,
	"./student-training/pyde/avatar2.png": 808,
	"./student-training/pyde/avatar3.png": 809,
	"./student-training/pyde/avatar4.png": 810,
	"./student-training/pyde/img1.png": 811,
	"./student-training/pyde/img2.png": 812,
	"./student-training/pyde/img3.png": 813,
	"./student-training/pyde/img4.png": 814,
	"./student-training/pyde/img5.png": 815,
	"./student-training/pyde/img6.png": 816,
	"./student-training/pyde/img7.png": 817,
	"./student-training/pyde/step-bg.png": 818,
	"./student-training/pyde/step-bg1.png": 127,
	"./student-training/pyde/step-bg2.png": 128,
	"./student-training/pyde/step-bg3.png": 129,
	"./student-training/pyde/step-bg4.png": 130,
	"./student-training/pyde/step-bg5.png": 131,
	"./student-training/pyde/title-icon.png": 819,
	"./student-training/pypi/icon-title.png": 820,
	"./student-training/pypi/section1-img1.png": 821,
	"./student-training/pypi/section2-img1.png": 3076,
	"./student-training/pypi/section3-img2.png": 822,
	"./student-training/pypi/section3-img3.png": 823,
	"./student-training/pypi/section3-img4.png": 824,
	"./student-training/pypi/section3-step1.png": 825,
	"./student-training/pypi/section3-step2.png": 826,
	"./student-training/pypi/section3-step3.png": 827,
	"./student-training/pypi/section3-step4.png": 828,
	"./student-training/pypi/step-bg.png": 829,
	"./student-training/quiz/mistakes_bg.png": 3077,
	"./student-training/quiz/mistakes_icon.png": 320,
	"./student-training/quiz/not_pass.png": 321,
	"./student-training/quiz/pass.png": 322,
	"./student-training/quiz/pass_upset.png": 323,
	"./student-training/quiz/pen-tool.png": 324,
	"./student-training/quiz/quiz.png": 325,
	"./student-training/quiz/scoreRating_pass_bg.png": 326,
	"./student-training/quiz/upset.png": 327,
	"./student-training/sso/icon-title.png": 830,
	"./student-training/sso/real-case-bg.png": 831,
	"./student-training/sso/section1-img2.png": 832,
	"./student-training/sso/section2-img1.png": 833,
	"./student-training/sso/section2-img2.png": 834,
	"./student-training/sso/section3-img1.png": 835,
	"./student-training/sso/section3-img2.png": 836,
	"./student-training/sso/section3-img3.png": 837,
	"./student-training/sso/section3-img4.png": 838,
	"./student-training/sso/section3-img5.png": 839,
	"./student-training/sso/section3-img6.png": 3078,
	"./student-training/sso/section3-img7.png": 3079,
	"./student-training/sso/step1-section3.png": 840,
	"./student-training/sso/step1.png": 841,
	"./student-training/sso/step2-section3.png": 842,
	"./student-training/sso/step2.png": 843,
	"./student-training/sso/step3-section3.png": 844,
	"./student-training/sso/step3.png": 845,
	"./student-training/sso/step4-section3.png": 846,
	"./student-training/sso/step4.png": 847,
	"./student-training/start_right.png": 3080,
	"./student.svg": 3081,
	"./student1.gif": 3082,
	"./student2.gif": 3083,
	"./student3.gif": 3084,
	"./student4.gif": 3085,
	"./studentRealCase1-en.png": 3086,
	"./studentRealCase1-mobile-en.png": 3087,
	"./studentRealCase1-mobile-sc.jpg": 1250,
	"./studentRealCase1-mobile.png": 3088,
	"./studentRealCase1-sc.jpg": 1251,
	"./studentRealCase1.png": 3089,
	"./studentRealCase2-en.png": 3090,
	"./studentRealCase2-mobile-en.png": 3091,
	"./studentRealCase2-mobile-sc.jpg": 1252,
	"./studentRealCase2-mobile.png": 3092,
	"./studentRealCase2-sc.jpg": 1253,
	"./studentRealCase2.png": 3093,
	"./support-org1.png": 3094,
	"./support-org2.png": 3095,
	"./support-org3.png": 3096,
	"./support-org4.png": 3097,
	"./test046.png": 3098,
	"./tip-arrow.png": 3099,
	"./tip1.png": 3100,
	"./tip2.png": 3101,
	"./tip3.png": 3102,
	"./tip4.png": 3103,
	"./tip5.png": 3104,
	"./tipbg.png": 3105,
	"./tips-person.png": 194,
	"./tips-person.svg": 3106,
	"./topic1.png": 3107,
	"./topic1200.png": 3108,
	"./topic1200bg.png": 3109,
	"./topic1400.png": 3110,
	"./topic1400bg.png": 3111,
	"./topic2.png": 3112,
	"./topic3.png": 3113,
	"./topic4.png": 3114,
	"./topic6.png": 3115,
	"./topic7.png": 3116,
	"./topic900.png": 3117,
	"./topic900bg.png": 3118,
	"./topic930.png": 3119,
	"./topic930bg.png": 3120,
	"./training-illustration.png": 3121,
	"./training-illustration10.png": 3122,
	"./training-illustration11.png": 3123,
	"./training-illustration12.png": 3124,
	"./training-illustration13.png": 3125,
	"./training-illustration2.png": 3126,
	"./training-illustration20.png": 3127,
	"./training-illustration21.png": 3128,
	"./training-illustration25.png": 3129,
	"./training-illustration26.png": 3130,
	"./training-illustration27.png": 3131,
	"./training-illustration3.png": 3132,
	"./training-illustration4.svg": 3133,
	"./training-illustration5.svg": 3134,
	"./training-illustration6.svg": 3135,
	"./training-illustration7.png": 3136,
	"./training-illustration8.png": 3137,
	"./training-illustration9.png": 3138,
	"./transcrip.png": 170,
	"./unhappy-emoji.png": 171,
	"./useful-link-Icon.png": 3139,
	"./vector.png": 3140,
	"./vector137.png": 3141,
	"./video1-en.mp4": 3142,
	"./video1.mp4": 3143,
	"./video1more.mp4": 3144,
	"./video2.mp4": 3145,
	"./warning-alert-bg.png": 3146,
	"./warning-alert-bg2.png": 3147,
	"./welc1.gif": 3148,
	"./welc2.gif": 3149,
	"./welc3.gif": 3150,
	"./welc4.gif": 3151,
	"./welcome.gif": 3152,
	"./welcomeInfo.png": 3153,
	"./welcomeInfo2.png": 3154,
	"./welcomeInfo3.png": 3155,
	"./welcomeLandingbg-E-commerce.png": 3156,
	"./welcomeLandingbg-fsi.png": 3157,
	"./welcomeLandingbg-general2024.png": 3158,
	"./welcomeLandingbg-it.png": 3159,
	"./welcomeLandingbg-ngo.png": 3160,
	"./welcomeLandingbg-startup.png": 3161,
	"./welcomeLandingbg-student.png": 3162,
	"./welcomeLandingbg.png": 3163,
	"./whatsApp.png": 3164,
	"./whatsAppRealcase-en-mobile.png": 3165,
	"./whatsAppRealcase-en.png": 3166,
	"./whatsAppRealcase-mobile.png": 3167,
	"./whatsAppRealcase.png": 3168,
	"./working.png": 3169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;